
import { MSAppPage } from "../../ms_front_lib/app/MSAppPage";
import { MSForm } from '../../ms_front_lib/forms/Forms';
import { HeroBuilder } from "../ui/HeroBuilder";
import { is_on_mobile } from "../app";
import { SliderBuilder } from "../ui/SliderBuilder";
import { Nav } from "../ui/Nav";
import { Prog } from "../utils/Prog";
import { MSDropDown } from "../../ms_front_lib/components/MSDropDown"; 
import ColorThief from "colorthief"
import Quill from "quill";

import './Custom.css';
import "quill/dist/quill.core.css";

export class PageCustom extends MSAppPage {
    constructor() {
        super("page-custom");
        this.is_page_init = false;
        this.page_id = null;
        this.page_config = null;
        this.prog_cine = null;
        this.superbillet_cine = null;
        this.live_preview = false;
        this.m_prog = null;
        this.list_files = [];
        this.today = null;
        this.$playing_video_carousel = null;
        this.list_$video_playing = [];
        this.selected_features_filter_prog = [];
        this.has_banner_image = false;

        // Chain (groupe)
        this.chain_events = [];
        this.num_cine_selected = localStorage.getItem("chain_num_cine_selected") ? localStorage.getItem("chain_num_cine_selected"):  null; // EMS9997, EMS9996, ...
    }
    
    title() { return _l(`${gl_config.name}`).format(gl_config.name)};
    seoDescription() { return _l(`customSEO`).format(gl_config.name)};
    seoKeywords() { return gl_app.seoKeywords()+','+_l(`customKeyword`)};

    $create(iQuery) {
        // console.log("PageCustom - $create", iQuery)
        if(!iQuery.hash){
            return;
        }
        moment.locale(gl_config.site ? gl_config.site.lang : "fr");
        this.today = moment().format("YYYY-MM-DD");
        this.page_id = iQuery.hash;

        let $res = $("<div/>").addClass("pane_page_custom").attr({"id":"pane_page_custom_"+this.page_id});
        return $res;
    }

    onBeforeOpen(iQuery) {
        // console.log("PageCustom - onBeforeOpen", iQuery)
        if(!iQuery.hash){
            window.location.replace("#home");
            return;
        }

        if(iQuery.refresh){
            window.location.replace("#"+iQuery.hash);
            window.location.reload();
        }

        if(iQuery.live_preview){
            this.live_preview = true;
        }

        // On fait cela pour na pas appeler le WS à chaque consultation de la page
        // Mais uniquement à son premier chargement
        if(!this.is_page_init){
            this.init_page();
        }

        this.page_id = iQuery.hash;

        this.find_banner_color();
    }

    async init(iQuery) {
        this.page_id = iQuery.hash;
        // Appel API récupération config de la page
        try{
            const res_api = await gl_api.get_website_docs({
                "docs" : ["page_"+this.page_id]
            });
            // console.log("Result get_website_docs",res_api)
            if(res_api.docs && res_api.docs["page_"+this.page_id]) {
                this.page_config = res_api.docs["page_"+this.page_id];
            }
        }catch(err){
            Overlay.hide();
            Swal.fire({
                icon:"warning",
                title:"Récupération config de la page",
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                // window.location.replace("#home");
            });
            // return;
        }
    }

    onOpen(iQuery) {
        // console.log("PageCustom - onOpen", iQuery, this.page_id)

        if(localStorage.getItem("chain_num_cine_selected") && localStorage.getItem("chain_num_cine_selected")!= this.num_cine_selected){
            this.num_cine_selected = localStorage.getItem("chain_num_cine_selected") ? localStorage.getItem("chain_num_cine_selected"): null; // EMS9997, EMS9996, ...
            window.location.reload();
        }

        $(".main-section").scrollTop(0);

        if(this.has_banner_image){
            $(".main-section").css({"margin-top": is_on_mobile() ? "-60px" : "-75px"});
        }
    }

    onQueryChanged(iQuery) {
        console.log("PageCustom - onQueryChanged", iQuery)
        if(iQuery.refresh){
            window.location.replace("#"+iQuery.hash);
            window.location.reload();
        }
        // if(!iQuery.hash){
        //     window.location.replace("#home");
        //     return;
        // }
        // this.page_id = iQuery.hash;
        // this.init_page();
    }

    onClose() {
        if($(".swal2-container").length > 0){
            $(".swal2-container .swal2-close").trigger("click")
        }
        if($(".modal").length > 0){
            $(".modal").remove();
            $(".modal-backdrop").remove();
        }
        $.each($('.tooltip'), function (index, element) {
            $(this).remove();
        });
        $(".main-section").css({"margin-top":"0px"});
        // On remet les couleurs par défaut
        $("nav").removeClass("black").removeClass("white");
        if(this.$playing_video_carousel){
            this.$playing_video_carousel[0].pause();
        }
        this.list_$video_playing.forEach(element => {
            element[0].pause();
        });
    }

    title() { 
        return this.page_config?.title ?? super.title();
    };

    seoDescription() 
    { 
        return this.page_config?.seo?.description;
    }

    seoKeywords() { 
        return this.page_config?.seo?.keywords;
    }

    async init_page() {
        // console.log("PageCustom - init_page", this.page_id)

        // this.num_cine_selected = "EMS9997"

        this.is_page_init = true;

        const $parent = $("#pane_page_custom_"+this.page_id);
        $parent.empty();

        // Récupération de la prog
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
                this.superbillet_cine = res_api.schedule.super_billets;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération programmation cinéma",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }else if(gl_config.type == "chain"){
            try {
                const res_api_events = await gl_api.get_events();
                this.chain_events = res_api_events;
                const res_api_sb = await gl_api.get_super_billets();
                this.m_prog = new Prog({
                    "events" : res_api_events,
                    "super_billets" : res_api_sb.super_billets
                });
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération des films du groupe",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }

        // console.log(this.page_config)

        if(!this.page_config){
            Overlay.hide();
            window.location.replace("#")
            return;
        }

        console.log("Page custom config ",this.page_config)

        var $main_container=$("<div/>").addClass("containe").appendTo($parent);
        if(this.live_preview){
            var $title=$("<h3/>").addClass("my-2 py-1 bold text-center").text(_l("Vous êtes en train de regarder une prévisualisation de votre page")).appendTo($main_container).css({
                "background-color" : "red"
            })
        }
        if(this.page_config.title){
            var $title=$("<div/>").addClass("h1 mt-3 ms-3").text(_l(this.page_config.title)).appendTo($main_container);
        }
        if(!this.page_config.blocks){
            Overlay.hide();
            return;
        }

        var $row=$("<div/>").addClass("row justify-content-center").attr({"id":"row_blocks_"+this.page_id}).appendTo($main_container);
        this.page_config.blocks.forEach((block, index) => {
            var block_id = "block_"+block.id
            if(block.data && block.data.label){
                block.data.label = block.data.label.replaceAll(" ","_").toLowerCase();
                block.data.label = block.data.label.replaceAll("'","").toLowerCase();
                block.data.label = block.data.label.replaceAll('"',"").toLowerCase();
                block.data.label = block.data.label.replaceAll(":","").toLowerCase();
                block.data.label = block.data.label.replaceAll("!","").toLowerCase();
                block.data.label = block.data.label.replaceAll("?","").toLowerCase();
                block.data.label = block.data.label.replaceAll(",","").toLowerCase();
                block.data.label = block.data.label.replaceAll(";","").toLowerCase();
                block.data.label = block.data.label.replaceAll("=","").toLowerCase();
                block.data.label = block.data.label.replaceAll("+","").toLowerCase();
                block.data.label = block.data.label.replaceAll("*","").toLowerCase();
                block.data.label = block.data.label.replaceAll("/","").toLowerCase();
                block.data.label = block.data.label.replaceAll("(","").toLowerCase();
                block.data.label = block.data.label.replaceAll(")","").toLowerCase();
                block.data.label = block.data.label.replaceAll("[","").toLowerCase();
                block.data.label = block.data.label.replaceAll("]","").toLowerCase();
                block.data.label = block.data.label.replaceAll("#","").toLowerCase();
                block.data.label = block.data.label.replaceAll("@","").toLowerCase();
                block.data.label = block.data.label.replaceAll("&","_").toLowerCase();
                block.data.label = block.data.label.replaceAll("à","a").toLowerCase();
                block.data.label = block.data.label.replaceAll("ù","u").toLowerCase();
                block.data.label = block.data.label.replaceAll("ü","u").toLowerCase();
                block.data.label = block.data.label.replaceAll("ï","i").toLowerCase();
                block.data.label = block.data.label.replaceAll("é","e").toLowerCase();
                block.data.label = block.data.label.replaceAll("è","e").toLowerCase();
                block.data.label = block.data.label.replaceAll("ë","e").toLowerCase();
                block.data.label = block.data.label.replaceAll("ö","o").toLowerCase();
                block.data.label = block.data.label.replaceAll("ô","o").toLowerCase();
                block_id += "_"+block.data.label;
            }
            block_id += "_"+index;

            // console.log(block)
            // Récupération de la largeur du block définit dans le BackOffice
            var col_value = "col-12";
            if(block.data && block.data.config && block.data.config.width){
                col_value += " col-md-"+block.data.config.width;
            }
            
            var $col=$("<div/>").addClass(col_value).attr({"id":"col_"+block_id}).addClass("d-flex").appendTo($("#row_blocks_"+this.page_id));
                var $block=$("<div/>").addClass("block flex-1").attr({"id":block_id}).appendTo($col);
            // var $block=$("<div/>").addClass("block").attr({"id":block_id}).appendTo($main_container);
            switch(block.id){
                case "banner":
                    this.$banner_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "carousel":
                    this.$carousel_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "image":
                    this.$image_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "link":
                    this.$link_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "map" : 
                    this.$map_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "media_grid":
                    this.$media_grid_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    })
                    break;
                case "movie" : 
                    this.$movie_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "movie_grid":
                    this.$movie_grid_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    })
                    break;
                case "newsletter_registration":
                    this.$newsletter_registration_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    })
                    break;
                case "slider":
                    $col.removeClass("d-flex");
                    this.$slider_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "simple_text":
                    this.$simple_text_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "video":
                    this.$video_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "text_image":
                    this.$text_image_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "text_video":
                    this.$text_video_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "program_cine":
                    this.$program_cine_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                case "search_bar_cinema":
                    setTimeout(() => {
                        this.$search_bar_cinema_block({
                            "block" : block,
                            "index" : index,
                            "$parent" : $block
                        });
                    }, 500);
                    break;
                case "separator":
                    this.$separation_block({
                        "block" : block,
                        "index" : index,
                        "$parent" : $block
                    });
                    break;
                default:
                    break;
            }
        });

        if(gl_config.type == "site"){
            gl_app.EMSBasket.update_qty_on_screen();
        }else if(gl_config.type == "chain"){
            
        }
    }

    async $banner_block(iParam){
        // console.log("PageCustom - $banner_block", iParam);
        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;

        this.has_banner_image = true;
        $(".main-section").css({"margin-top": is_on_mobile() ? "-60px" : "-75px"});
        $("#block_"+iBlock.id+"_"+data.label+"_"+block_index).remove();

        if(data.config.banner_type == "auto"){
            this.hero_builder = new HeroBuilder();
            this.hero_builder.$create({
                "type" : "auto"
            }).prependTo($("#pane_page_custom_"+this.page_id));
        }else if(data.config.banner_type == "custom"){
            let tab_media_api = [];
            let tab_file_api = [];
            data.config.medias.forEach(media => {
                tab_media_api.push("media_"+media);
            });
            // Appel API récupération config des médias du slider
            let res_api_media;
            let res_api_file;
            try{
                res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
                // console.log("Result get_website_docs media",res_api_media)
                if(!res_api_media.docs) {
                    Swal.fire({
                        icon:"warning",
                        title:"Récupération config des médias du slider "+data.label,
                        showCloseButton : true,
                        text: _l("Echec de la récupération"),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : false,
                        customClass: {
                            icon : "align-items-center"
                        }
                    });
                }

                // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
                Object.values(res_api_media.docs).forEach(media => {
                    if(media.link && media.link.type == "file"){
                        tab_file_api.push("file_"+media.link.file_id);
                    }
                });

                if(tab_file_api.length > 0){
                    res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                    Object.values(res_api_file.docs).forEach(file => {
                        // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                        if(this.list_files.filter(f => f.id == file.id) <=0 ){
                            this.list_files.push(file);
                        }
                    });
                }
                // console.log("Result get_website_docs files",res_api_file)

            }catch(err){
                Overlay.hide();
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config des médias du slider "+data.label,
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
                // return;
            }

            var media = Object.values(res_api_media.docs)[0]
            media.media_url = media.media_url.replace("/120x","/1920px");
            media.media_url = media.media_url.replace("/600x","/1920x");
            media.media_url = media.media_url.replace("/320","/1920");
            media.media_url = media.media_url.replace("/600","/1920");

            this.hero_builder = new HeroBuilder();
            this.hero_builder.$create({
                "data" : {
                    "text_btn" : data.config.text_btn_banner ? data.config.text_btn_banner : "",
                    "title" : data.config.title_banner,
                    "url" : media.media_url,
                    "action" : media.link && media.link.type != "none" ? (e) => {
                        e.preventDefault();
                        self.set_media_action(media)
                    } : null
                },
                "type" : "custom"
            }).prependTo($("#pane_page_custom_"+this.page_id));
        }
    }

    async $carousel_block(iParam) {
        // console.log("PageCustom - $carousel_block", iParam);
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }
        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        let has_media_valid = false;
        let tab_media_api = [];
        let tab_file_api = [];
        data.config.medias.forEach(media => {
            tab_media_api.push("media_"+media);
        });
        // Appel API récupération config des médias du slider
        let res_api_media;
        let res_api_file;
        try{
            res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
            // console.log("Result get_website_docs media",res_api_media)
            if(!res_api_media.docs) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config des médias du slider "+data.label,
                    showCloseButton : true,
                    text: _l("Echec de la récupération"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                });
            }

            // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
            Object.values(res_api_media.docs).forEach(media => {
                if(media.link && media.link.type == "file"){
                    tab_file_api.push("file_"+media.link.file_id);
                }
            });

            if(tab_file_api.length > 0){
                res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                Object.values(res_api_file.docs).forEach(file => {
                    // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                    if(this.list_files.filter(f => f.id == file.id) <=0 ){
                        this.list_files.push(file);
                    }
                });
            }
            // console.log("Result get_website_docs files",res_api_file)

        }catch(err){
            Overlay.hide();
            Swal.fire({
                icon:"warning",
                title:"Récupération config des médias du slider "+data.label,
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                // window.location.replace("#home");
            });
            // return;
        }

        var $wrap=$("<div/>").addClass("wrap wrap_media").appendTo(iParam.$parent).css({
            "background-color" : "transparent"
        })
            var $carousel=$("<div/>").addClass("carousel slide").attr({"id":iBlock.id+"_"+data.label+"_"+block_index, "data-bs-ride":"carousel"}).appendTo($wrap);
                // indicators
                var $carousel_indicators=$("<ol/>").addClass("carousel-indicators").appendTo($carousel);
                // carousel inner
                var $carousel_inner=$("<div/>").addClass("carousel-inner").appendTo($carousel);
                // controls
                var $control_prev=$("<button/>").addClass("carousel-control-prev").attr({"type":"button","data-bs-target":"#"+iBlock.id+"_"+data.label+"_"+block_index , "data-bs-slide":"prev"}).appendTo($carousel);
                    $("<span/>").addClass("carousel-control-prev-icon").attr({"aria-hidden":true}).appendTo($control_prev);
                    $("<span/>").addClass("visually-hidden").text("Précédent").appendTo($control_prev);
                var $control_next=$("<button/>").addClass("carousel-control-next").attr({"type":"button","data-bs-target":"#"+iBlock.id+"_"+data.label+"_"+block_index , "data-bs-slide":"next"}).appendTo($carousel);
                    $("<span/>").addClass("carousel-control-next-icon").attr({"aria-hidden":true}).appendTo($control_next);
                    $("<span/>").addClass("visually-hidden").text("Suivant").appendTo($control_next);

        let index_item = 0; // Certains médias ne seront pas affichés car hors période de validité, on ne se sert pas de l'index auto du parcours. (sinon bug)
        Object.values(res_api_media.docs).forEach((media,index) => {
            // Gestion des dates de validité d'affichage du media
            if(media.validity && media.validity.type == "date"){
                var from = media.validity.from;
                var to = media.validity.to;
                if(from > this.today || to < this.today){
                    return;
                }
            }
            has_media_valid = true;
            var $item=$("<div/>").addClass("carousel-item").data({"media_data":media}).appendTo($carousel_inner);
                if(media.type == "image"){
                    $item.attr({"data-bs-interval":"5000"})
                    media.media_url = media.media_url.replace("/120x","/1920x");
                    media.media_url = media.media_url.replace("/600x","/1920x");
                    media.media_url = media.media_url.replace("/320","/1920");
                    media.media_url = media.media_url.replace("/600","/1920");
                    var $media=$("<img/>").addClass("img_media").attr({"src":media.media_url, "alt":""}).appendTo($item);
                }
                if(media.type == "video"){
                    $item.attr({"data-bs-interval":"10000"})
                    media.thumbnail_url = media.thumbnail_url.replace("/120x","/1920x");
                    media.thumbnail_url = media.thumbnail_url.replace("/600x","/1920x");
                    media.thumbnail_url = media.thumbnail_url.replace("/320","/1920");
                    media.thumbnail_url = media.thumbnail_url.replace("/600","/1920");
                    media.media_url = media.media_url.replace("/ld","/hd");
                    var $media=$("<video/>").addClass("img_media").attr({"src":media.media_url, "controls":is_on_mobile() ? false : true, "controlslist":"nofullscreen", "poster":media.thumbnail_url, "id":"video_id_"+media.id, "webkit-playsinline":"", "playsinline":"", "loop":""}).appendTo($item);
                }
                if(media.description){
                    var $caption=$("<div/>").addClass("carousel-caption").appendTo($item);
                        var $description=$("<div/>").addClass("description_img m-auto").text(media.description).appendTo($caption);
                }

            $("<button/>").attr({"type":"button", "data-bs-target":"#"+iBlock.id+"_"+data.label+"_"+block_index,"data-bs-slide-to":index_item}).appendTo($carousel_indicators);

            // Gestion du click du media
            $media.on("click", function (e) {
                e.preventDefault()
                if(!self.is_dragging){
                    self.set_media_action(media);
                }
            });

            if(media.link && media.link.type != "none"){
                $media.addClass("pointer");
            }

            index_item ++;
        });

        if(has_media_valid){
            $(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+" .carousel-item").first().addClass("active");
            $(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+" .carousel-indicators button").first().addClass("active");
            $carousel.on("slide.bs.carousel",(event) => {
                if(this.$playing_video_carousel){
                    this.$playing_video_carousel[0].pause();
                }
                if($(event.relatedTarget).data("media_data").type == "video"){
                    this.$playing_video_carousel = $(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+" #video_id_"+$(event.relatedTarget).data("media_data").id);
                    var video_duration = this.$playing_video_carousel[0].duration;
                    var video_current_time = this.$playing_video_carousel[0].currentTime;
                    var time_internal = parseInt((video_duration - video_current_time) * 1000);
                    $(event.relatedTarget).attr({"data-bs-interval":time_internal});
                    this.$playing_video_carousel.prop("muted",true);
                    this.$playing_video_carousel[0].play();
                }
            });

            // Si le premier élément est une vidéo
            setTimeout(() => {
                if($(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+" .carousel-item").first().data("media_data").type == "video"){
                    this.$playing_video_carousel = $(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+" #video_id_"+$(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+" .carousel-item").first().data("media_data").id);
                    var video_duration = this.$playing_video_carousel[0].duration;
                    var video_current_time = this.$playing_video_carousel[0].currentTime;
                    var time_internal = parseInt((video_duration - video_current_time) * 1000);
                    $(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+" .carousel-item").first().attr({"data-bs-interval":time_internal});
                    this.$playing_video_carousel.prop("muted",true);
                    this.$playing_video_carousel[0].play();
                }
            }, 250);

            new bootstrap.Carousel($(".carousel#"+iBlock.id+"_"+data.label+"_"+block_index+""), {
                // interval: 5000,
                wrap: true,
                ride : "carousel"
            })
        }else{
            $("#block_"+iBlock.id+"_"+data.label+"_"+block_index).remove();
        }
    }

    async $image_block(iParam) {
        // console.log("PageCustom - $image_block", iBlock);
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }
        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        let tab_media_api = [];
        let tab_file_api = [];
        data.config.medias.forEach(media => {
            tab_media_api.push("media_"+media);
        });
        // Appel API récupération config des médias du slider
        let res_api_media;
        let res_api_file;
        try{
            res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
            // console.log("Result get_website_docs media",res_api_media)
            if(!res_api_media.docs) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config des médias du slider "+data.label,
                    showCloseButton : true,
                    text: _l("Echec de la récupération"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                });
            }

            // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
            Object.values(res_api_media.docs).forEach(media => {
                if(media.link && media.link.type == "file"){
                    tab_file_api.push("file_"+media.link.file_id);
                }
            });

            if(tab_file_api.length > 0){
                res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                Object.values(res_api_file.docs).forEach(file => {
                    // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                    if(this.list_files.filter(f => f.id == file.id) <=0 ){
                        this.list_files.push(file);
                    }
                });
            }
            // console.log("Result get_website_docs files",res_api_file)

        }catch(err){
            Overlay.hide();
            Swal.fire({
                icon:"warning",
                title:"Récupération config des médias du slider "+data.label,
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                // window.location.replace("#home");
            });
            // return;
        }

        var media = Object.values(res_api_media.docs)[0]
        media.media_url = media.media_url.replace("/120x","/1920x");
        media.media_url = media.media_url.replace("/600x","/1920x");
        media.media_url = media.media_url.replace("/320","/1920");
        media.media_url = media.media_url.replace("/600","/1920");

        // Gestion des dates de validité d'affichage du media
        if(media.validity && media.validity.type == "date"){
            var from = media.validity.from;
            var to = media.validity.to;
            if(from > this.today || to < this.today){
                return;
            }
        }

        // On regarde si le bloc image est de type bannière
        if(data.config.is_banner_page && !this.has_banner_image){
            // this.has_banner_image = true;
            // $(".main-section").css({"margin-top": is_on_mobile() ? "-60px" : "-75px"});
            // $("#block_"+iBlock.id+"_"+data.label).remove();
            // this.hero_builder = new HeroBuilder();
            // this.hero_builder.$create({
            //     "data" : {
            //         "text_btn" : data.config.text_btn_banner ? data.config.text_btn_banner : "",
            //         "title" : data.config.title,
            //         "url" : media.media_url,
            //         "action" : media.link && media.link.type != "none" ? (e) => {
            //             e.preventDefault();
            //             self.set_media_action(media)
            //         } : null
            //     },
            //     "type" : "custom"
            // }).prependTo($("#pane_page_custom_"+this.page_id));
        }else{
            var $wrap=$("<div/>").addClass("wrap wrap_media").appendTo(iParam.$parent);
                var $row=$("<div/>").addClass("row").appendTo($wrap);
                    var $col=$("<div/>").addClass("col-12").appendTo($row);
                        var $poster_container=$("<div/>").addClass("poster_container mx-auto").appendTo($col);
                        var $img=$("<img/>").addClass("poster media_image").attr({"src":media.media_url, "alt":""}).appendTo($poster_container);
                            if(media.description){
                                var $flexbox=$("<div/>").addClass("box_details").appendTo($poster_container);
                                    var $description=$("<div/>").addClass("description_img m-auto").text(media.description).appendTo($flexbox);
                            }

            if(media.link && media.link.type != "none"){
                $img.addClass("pointer");

                $img.on("click", function (e) {
                    e.preventDefault();
                    self.set_media_action(media)
                });
            }
        }
    }

    async $link_block(iParam) {
        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        var tab_file_api = [];
        var $wrap=$("<div/>").addClass("wrap wrap_media d-flex").appendTo(iParam.$parent);
            var $link=$("<a/>").addClass("link").attr({"href":data.config.file_url+"?name="+encodeURIComponent(data.config.file_name)}).text(data.config.text).appendTo($wrap);

        if(data.config){
            if(data.config.style_btn){
                $wrap.addClass("btn p-0");
            }
            if(data.config.border){
                $wrap.addClass("border-ms");
            }

            if(data.config.link && data.config.link.type != "none"){
                $link.removeAttr("href");
                $wrap.addClass("pointer");

                if(data.config.link.type == "file"){
                    // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
                    tab_file_api.push("file_"+data.config.link.file_id);

                    if(tab_file_api.length > 0){
                        var res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                        Object.values(res_api_file.docs).forEach(file => {
                            // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                            if(this.list_files.filter(f => f.id == file.id) <=0 ){
                                this.list_files.push(file);
                            }
                        });
                    }
                }

                $wrap.on("click", function (e) {
                    e.preventDefault();
                    self.set_media_action(data.config)
                });
            }else if(!data.config.file_url){
                iParam.$parent.remove();
            }
        } 
    }

    $map_block(iParam) {
        const block_index = iParam.index;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const street = data && data.config && data.config.street && data.config.street != "" ? data.config.street : gl_config.site.address.street;
        const zip_code = data && data.config && data.config.zip_code && data.config.zip_code != "" ? data.config.zip_code : gl_config.site.address.zip_code;
        const city = data && data.config && data.config.city && data.config.city != "" ? data.config.city : gl_config.site.address.city;
        let map_url = "https://maps.google.com/maps";
        map_url += "?q="+encodeURIComponent(street+", "+zip_code+" "+city);
        map_url += "&output=embed";

        var $wrap=$("<div/>").addClass("wrap wrap_map").attr({"id":"wrap_map"+"_"+block_index}).appendTo(iParam.$parent);
            var $map=$("<div/>").addClass("map").appendTo($wrap);
                var $iframe=$("<iframe/>").attr({"src":map_url, "loading":"lazy", "allowfullscreen":"", "referrerpolicy":"no-referrer-when-downgrade", "title":"map"}).appendTo($map)
    }

    async $media_grid_block(iParam){
        // console.log("PageCustom - $media_grid_block", iParam);
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }

            if(!this.prog_cine || this.prog_cine.length <= 0){
                return;
            }
        }

        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        let has_media_valid = false;

        if(data.config.medias.length < 0){
            $("#block_"+iBlock.id+"_"+data.label+"_"+block_index).remove();
            return;
        }

        let tab_media_api = [];
        let tab_file_api = [];
        data.config.medias.forEach(media => {
            tab_media_api.push("media_"+media);
            if(media.link && media.link.type == "file"){
                tab_file_api.push("file_"+media.link.file_id);
            }
        });

        // Appel API récupération config des médias
        let res_api_media;
        let res_api_file;
        try{
            res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
            // console.log("Result get_website_docs media",res_api_media)
            if(!res_api_media.docs) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config des médias "+data.label,
                    showCloseButton : true,
                    text: _l("Echec de la récupération"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                });
            }

            // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
            Object.values(res_api_media.docs).forEach(media => {
                if(media.link && media.link.type == "file"){
                    tab_file_api.push("file_"+media.link.file_id);
                }
            });

            if(tab_file_api.length > 0){
                res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                Object.values(res_api_file.docs).forEach(file => {
                    // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                    if(this.list_files.filter(f => f.id == file.id) <=0 ){
                        this.list_files.push(file);
                    }
                });
            }
            // console.log("Result get_website_docs files",res_api_file)
        }catch(err){
            Overlay.hide();
            Swal.fire({
                icon:"warning",
                title:"Récupération config des médias du slider "+data.label,
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                // window.location.replace("#home");
            });
            // return;
        }

        var $wrap=$("<div/>").addClass("wrap wrap_media_grid").attr({"id":"wrap_media_grid"+data.label+"_"+block_index}).appendTo(iParam.$parent);
            if(data.config.title){
                var $title=$("<div/>").addClass("title").text(data.config.title).appendTo($wrap);
            }
            var $row=$("<div/>").addClass("row my-2 my-md-4 mx-0 mx-md-1 justify-content-center").appendTo($wrap);
            Object.values(res_api_media.docs).forEach(media => {
                // Gestion des dates de validité d'affichage du media
                if(media.validity && media.validity.type == "date"){
                    var from = media.validity.from;
                    var to = media.validity.to;
                    if(from > this.today || to < this.today){
                        return;
                    }
                }
                has_media_valid = true;

                var $col=$("<div/>").addClass("col-12 col-md-4 my-2 box_media").appendTo($row);

                if(media.type == "image"){
                    media.media_url = media.media_url.replace("/120x","/800x");
                    media.media_url = media.media_url.replace("/320","/800");
                    var $media=$("<img/>").addClass("img_media").attr({"src":media.media_url, "alt":""}).appendTo($col);
                }
                if(media.type == "video"){
                    media.thumbnail_url = media.thumbnail_url.replace("/120x","/800x");
                    media.thumbnail_url = media.thumbnail_url.replace("/320","/800");
                    media.media_url = media.media_url.replace("/ld","/hd");
                    var $media=$("<video/>").addClass("img_media").attr({"src":media.media_url, "controls":true, "poster":media.thumbnail_url, "id":"video_id_"+media.id, "webkit-playsinline":"", "playsinline":"", "loop":""}).appendTo($col);
                }
                if(media.description){
                    var $flexbox=$("<div/>").addClass("box_details").appendTo($col);
                        var $description=$("<div/>").addClass("description_img m-auto").text(media.description).appendTo($flexbox);
                }
                if(media.title) {
                    var $title=$("<div/>").addClass("media_title").text(media.title).appendTo($col);
                }

                if(media.link && media.link.type != "none"){
                    $col.addClass("pointer");
    
                    $col.on("click", function (e) {
                        e.preventDefault();
                        self.set_media_action(media)
                    });
                }
            });

        if(!has_media_valid){
            $("#block_"+iBlock.id+"_"+data.label+"_"+block_index).remove();
        }
    }

    async $movie_block(iParam) {
        // console.log("PageCustom - $movie_block", iParam);
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }

        const self = this;

        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        const movie = data.movie;
        movie.certification = this.m_prog.ParseCertification(movie.certification_id);
        movie.runtime = this.m_prog.timeConvert(movie.duration);
        // console.log("movie",movie)
        // console.log("this.prog_cine",this.prog_cine)
        // console.log("movie_in_prog",movie_in_prog)
        const movie_in_prog = gl_config.type == "site" && this.prog_cine && this.prog_cine.filter(event => event.id == movie.id)[0] ? this.prog_cine.filter(event => event.id == movie.id)[0] : null;
        var poster_url = movie.bill_url ? movie.bill_url : "https://static.monnaie-services.com/www-img/ticketingcine/no_poster_imsweb.webp";
        if(poster_url){
            if(is_on_mobile()){
                poster_url = poster_url.replace("/120","/320");
            }else{
                poster_url = poster_url.replace("/120","/600");
            }
        }

        var use_mobile_class = false;
        // Sur mobile on met les colonnes en pleines largeur peut importe la config, donc pas besoin du code ci-dessous
        if(!is_on_mobile()){
            if(iBlock.data && iBlock.data.config && iBlock.data.config.width && iBlock.data.config.width <= 6){
                use_mobile_class = true;
            }
        }else{
            use_mobile_class = true;
        }
        

        var $wrap=$("<div/>").addClass("wrap wrap_movie_details h-100").attr({"id":"wrap_movie_details_"+data.label+"_"+block_index}).appendTo(iParam.$parent)
            var $bg_color=$("<div/>").addClass("bg_color h-100").appendTo($wrap);
                var $container=$("<div/>").addClass("container py-3 py-md-5 d-flex ").addClass(use_mobile_class ? "flex-column" : "flex-row").appendTo($bg_color);
                    var $wrap=$("<div/>").addClass("d-flex justify-content-end").attr({"id":"movie_tools"}).appendTo($container);
                        let $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_share_nodes")[0].svg_text).appendTo($wrap).on("click",() => {
                            gl_app.share_url(window.location.href, movie.title + " - " + gl_config.site.name + " - " + gl_config.site.address.city);
                        });
                    var $poster_container=$("<div/>").addClass("poster_container m-auto").appendTo($container);
                        var $poster=$("<img/>").addClass("poster").attr({"src":poster_url, "loading":"lazy", "alt":movie.title}).appendTo($poster_container);
                        var $poster_header=$("<div/>").addClass("poster_header d-flex").appendTo($poster_container);
                        if(movie.certification && movie.certification.img){
                            var $img_certification=$("<img/>").addClass("img_certification my-auto").attr({"src":movie.certification.img, "loading":"lazy", "alt":""}).appendTo($poster_header);
                        }
                        if(movie.trailer_url){
                            var $corner_fold=$("<div/>").addClass("bottom-left-corner-fold").appendTo($poster_container);
                            let $svg_container = $("<div/>").addClass("svg_container icon icon_svg play-icon").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_circle_play")[0].svg_text).appendTo($poster_container).on("click",() => {
                                this.m_prog.player_trailer(movie.trailer_url)
                            })
                        }

                    var $movie_info_container=$("<div/>").addClass("movie_info_container flex-1 ms-2 ms-md-4").appendTo($container)
                        var $title=$("<h2/>").addClass("movie_title").addClass(use_mobile_class ? "text-center pt-2" : "text-start").text(movie.title).appendTo($movie_info_container);
                        var $wrap=$("<div/>").addClass("d-flex flex-wrap facts").addClass(use_mobile_class ? "justify-content-center" : "justify-content-start").appendTo($movie_info_container);
                            // if(movie.certification_id){
                            //     var $certification_id=$("<span/>").addClass("certification").text(movie.certification_id).appendTo($wrap);
                            // }
                            if(movie.certification && movie.certification.text){
                                var $certification_id=$("<span/>").addClass("certification").text(movie.certification.text).appendTo($wrap);
                            }
                            if(movie.release_date){
                                var $release_date=$("<span/>").addClass("release_date").text(moment(movie.release_date).format("DD/MM/YYYY")).appendTo($wrap);
                                var $span=$("<span/>").addClass("").text("•").appendTo($wrap);
                            }
                            if(movie.localized_genres && !Array.isArray(movie.localized_genres)){
                                movie.localized_genres = movie.localized_genres.replaceAll(",",", ")
                                var $kind=$("<span/>").addClass("kind capitalize").text(movie.localized_genres).appendTo($wrap);
                                var $span=$("<span/>").addClass("").text("•").appendTo($wrap);
                            }
                            if(movie.duration) {
                                var $duration=$("<span/>").addClass("runtime").text(movie.runtime).appendTo($wrap);
                            }
                        if(movie_in_prog && movie_in_prog.custom_tags){
                            var $movie_custom_tags_container=$("<div/>").addClass("movie_custom_tags_container mt-2 mt-md-3").appendTo($movie_info_container);
                            movie_in_prog.custom_tags.forEach(tag_id => {
                                const data_tag = gl_custom_prog_tags[tag_id];
                                if(!data_tag){
                                    return;
                                }
                                var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($movie_custom_tags_container);
                            });
                        }
                        if(movie.synopsis){
                            var $wrap=$("<div/>").addClass("mt-3 mt-md-5").appendTo($movie_info_container);
                                var $label=$("<h4/>").addClass("").text(_l("Synopsis")).appendTo($wrap);
                                var $synopsis=$("<span/>").addClass("synopsis").text(movie.synopsis).appendTo($wrap);
                        }
                        var $wrap=$("<div/>").addClass("d-flex").addClass(use_mobile_class ? "flex-column mt-3" : "flex-md-row mt-5").appendTo($movie_info_container);
                            if(movie.director){
                                var $box=$("<div/>").addClass("me-md-5").appendTo($wrap);
                                    var $text=$("<div/>").addClass("bold").text(_l("Réalisateur")).appendTo($box);
                                    var $text=$("<h6/>").addClass("text").text(movie.director).appendTo($box);
                            }
                            if(movie.actors){
                                var $box=$("<div/>").addClass("").appendTo($wrap);
                                    var $text=$("<div/>").addClass("bold").text(_l("Acteurs")).appendTo($box);
                                    var $text=$("<h6/>").addClass("text").text(movie.actors).appendTo($box);   
                            }              

        if(movie.bill_url || (movie.backdrop_urls && movie.backdrop_urls.length>0)){
            if(!is_empty({"obj":movie.backdrop_urls})){
                movie.backdrop_urls = Object.values(movie.backdrop_urls)
            }
            var backdrop_img = movie.backdrop_urls ? movie.backdrop_urls[0] : movie.bill_url;
            backdrop_img = backdrop_img.replace("/120","/1920");
            
            $("#pane_page_custom_"+self.page_id+" #wrap_movie_details_"+data.label+"_"+block_index).css({
                "background-image" : "url("+backdrop_img+")",
            });

            const colorThief = new ColorThief();
            const img = new Image();

            img.addEventListener('load', function() {
                let rgb = colorThief.getColor(img);
                if(rgb[0]+rgb[1]+rgb[2]>350){
                    $("#pane_page_custom_"+self.page_id+" #wrap_movie_details_"+data.label+"_"+block_index+" *").css({
                        "color":"black",
                        "fill":"black"
                    })
                }else{
                    $("#pane_page_custom_"+self.page_id+" #wrap_movie_details_"+data.label+"_"+block_index+" *").css({
                        "color":"white",
                        "fill":"white"
                    })
                }
                $("#pane_page_custom_"+self.page_id+" #wrap_movie_details_"+data.label+"_"+block_index+" .bg_color").css({
                    "background-image" : "linear-gradient(to right, rgba("+rgb[0]+", "+rgb[1]+", "+rgb[2]+", 1) calc((50vw - 170px) - 340px), rgba("+rgb[0]+", "+rgb[1]+", "+rgb[2]+", 0.84) 50%, rgba("+rgb[0]+", "+rgb[1]+", "+rgb[2]+", 0.84) 100%)"
                })
            });

            img.crossOrigin = 'Anonymous';
            img.src = backdrop_img;
        }  

        if(gl_config.type == "site"){
            $movie_info_container.addClass("pointer");
            $movie_info_container.on("click",() => {
                window.location.href = "#showmovie?id="+movie.id
            });
        }else if(gl_config.type == "chain"){
            $movie_info_container.addClass("pointer");
            $movie_info_container.on("click",() => {
                window.location.href = "#showmovie?id="+movie.id
            });
        }
    }

    async $movie_grid_block(iParam) {
        // console.log("PageCustom - $movie_grid_block", iParam);
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }

            if(!this.prog_cine || this.prog_cine.length <= 0){
                return;
            }
        }

        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        const categorie = data.config.categorie;
        let movies_list = [];

        if(!categorie){
            return;
        }

        movies_list = await this.m_prog.filter_events({
            "categorie" : categorie,
            "num_cine_selected" : this.num_cine_selected,
            "website_type" : gl_config.type,
            "data" : data
        });

        if(movies_list.length <= 0){
            $("#block_"+iBlock.id+"_"+data.label+"_"+block_index).remove();
            return;
        }

        var $wrap=$("<div/>").addClass("wrap wrap_movie_grid").attr({"id":"wrap_movie_grid"+data.label+"_"+block_index}).appendTo(iParam.$parent);
            if(data.config.title){
                var $title=$("<div/>").addClass("title").text(data.config.title).appendTo($wrap);
            }
            var $row=$("<div/>").addClass("row my-2 my-md-4 mx-0 mx-md-1 justify-content-center").appendTo($wrap);
            movies_list.forEach(movie => {
                // console.log("$movie_grid_block - movie", movie)
                movie.certification = this.m_prog.ParseCertification(movie.certification_id);
                movie.runtime = this.m_prog.timeConvert(movie.duration);
                const movie_in_prog = gl_config.type == "site" && this.prog_cine && this.prog_cine.filter(event => event.id == movie.id)[0] ? this.prog_cine.filter(event => event.id == movie.id)[0] : null;
                // console.log(movie)
                // console.log("movie_in_prog",movie_in_prog)
                var poster_url = movie.bill_url ? movie.bill_url : "https://static.monnaie-services.com/www-img/ticketingcine/no_poster_imsweb.webp";
                if(poster_url){
                    if(is_on_mobile()){
                        poster_url = poster_url.replace("/120","/320");
                    }else{
                        poster_url = poster_url.replace("/120","/600");
                    }
                }

                var $col=$("<div/>").addClass("col-6 col-md-3 my-2").appendTo($row);
                    var $flexbox=$("<div/>").addClass("d-flex flex-column box_movie").appendTo($col);
                        var $poster_container=$("<div/>").addClass("poster_container mx-auto").appendTo($flexbox);
                            var $poster=$("<img/>").addClass("poster").attr({"src":poster_url, "loading":"lazy", "alt":movie.title}).appendTo($poster_container);
                            var $poster_header=$("<div/>").addClass("poster_header d-flex").appendTo($poster_container);
                            if(movie.certification && movie.certification.img){
                                var $img_certification=$("<img/>").addClass("img_certification my-auto").attr({"src":movie.certification.img, "loading":"lazy", "alt":""}).appendTo($poster_header);
                            }
                            if(movie.trailer_url){
                                var $corner_fold=$("<div/>").addClass("bottom-left-corner-fold").appendTo($poster_container);
                                    let $svg_container = $("<div/>").addClass("svg_container icon icon_svg play-icon").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_circle_play")[0].svg_text).appendTo($poster_container).on("click",(e) => {
                                        e.stopPropagation();
                                        this.m_prog.player_trailer(movie.trailer_url)
                                    })
                            }

                            if(movie_in_prog && movie_in_prog.custom_tags){
                                var $movie_custom_tags_container=$("<div/>").addClass("movie_custom_tags_container mt-2 mt-md-3").appendTo($movie_info_container);
                                movie_in_prog.custom_tags.forEach(tag_id => {
                                    const data_tag = gl_custom_prog_tags[tag_id];
                                    if(!data_tag){
                                        return;
                                    }
                                    var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($poster_header);
                                });
                            }

                        var $movie_info_container=$("<div/>").addClass("movie_info_container d-flex flex-column w-100").appendTo($flexbox);
                            var $title=$("<div/>").addClass("movie_title").text(movie.title).appendTo($movie_info_container);
                            if(movie.localized_genres && !Array.isArray(movie.localized_genres)){
                                movie.localized_genres = movie.localized_genres.replaceAll(",",", ")
                                var $kind=$("<span/>").addClass("kind capitalize").text(movie.localized_genres).appendTo($movie_info_container);
                                // var $span=$("<span/>").addClass("").text("•").appendTo($movie_info_container);
                            }

                if(gl_config.type == "site"){
                    $col.addClass("pointer");
                    $col.on("click",() => {
                        window.location.href = categorie == "superbillet" ? "#showsuperbillet?id="+movie.id : "#showmovie?id="+movie.id
                    });
                }else if(gl_config.type == "chain"){
                    $col.addClass("pointer");
                    $col.on("click",() => {
                        if(categorie == "superbillet"){
                            let site_config = gl_config.chain.sites.filter(site => site.id == movie.site_id)[0];
                            let href = site_config && site_config.website_full_url ? site_config.website_full_url : "https://www.ticketingcine.com/?"+movie.site_id;
                            href += "#showsuperbillet?id="+movie.id;
                            window.open(href,"_blank");
                        }else{
                            window.location.href = "#showmovie?id="+movie.id;
                        }
                    });
                }
            });
    }

    $newsletter_registration_block(iParam) {
        var $wrap=$("<div/>").addClass("wrap").attr({"id":"wrap_newsletter_registration"}).appendTo(iParam.$parent);
            var $text=$("<div/>").addClass("title").text(_l("Inscrivez-vous à la newsletter")).appendTo($wrap);
            var $text=$("<div/>").addClass("accroche").text(_l("Restez informé!")).appendTo($wrap);
            var $text=$("<div/>").addClass("accroche").text(_l("Toute l'actu, bon plan et autre évènement de votre cinéma préféré dans cette newsletter.")).appendTo($wrap);
            this.form_newsletter = new MSForm({
                fields: [
                    {
                        type: "fl_text",
                        cols: [10],
                        class: "mx-auto",
                        key: "email",
                        label: _l("Votre adresse email")
                    }
                ],
                bind_focus_out : false
            })
            this.form_newsletter.$create().appendTo($wrap);
            var $btn=$("<button/>").addClass("btn btn-lg my-2 my-md-4 mx-auto").attr({"id":"btn_newsletter_register"}).text(_l("Valider")).appendTo($wrap).on("click",async () => {
                const data = this.form_newsletter.getValue();
                if(!data.email || data.email==""){
                    $("input[key=email]").addClass("is-invalid")
                    return;
                }

                try {
                    const res = await gl_api.register_newsletter({
                        "email" : data.email
                    });
                    Overlay.hide();
                } catch (err) {
                    Overlay.hide();
                    Swal.fire({
                        icon:"warning",
                        title:"Inscription newsletter",
                        showCloseButton : true,
                        text: _l(err.data ? err.data.message : err),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : false,
                        customClass: {
                            icon : "align-items-center"
                        }
                    }).then((result) => {
                        // window.location.replace("#home");
                    });
                    return;
                }

                Swal.fire({
                    icon:"success",
                    title:"",
                    showCloseButton : true,
                    html : "<div>Un email vient de vous être envoyé à l'adresse email</div>"+
                    "<div class='bold my-3'>"+data.email+"</div>"+
                    "<div>Veuillez cliquez sur le lien se trouvant dans celui-ci afin de confirmer votre inscription à la newsletter.</div>",
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false
                });

            });
            var $text=$("<div/>").addClass("description").text(_l("En raison du règlement Général sur la Protection des Données personnelles (RGPD) en vigueur depuis mai 2018 nous vous confirmons l’utilisation exclusive de vos informations dans le cadre de l’actualité du cinéma. ")).appendTo($wrap);

            $("input[key=email]").on("keypress",(e) => {
                $(e.currentTarget).removeClass("is-invalid")
            })
    }

    async $program_cine_block(iParam) {
        if(gl_config.type == "site" && !this.m_prog){
            let res_api;
            try{
                res_api = await gl_api.getProg();
                // console.log("Result getProg",res_api)
                this.m_prog = new Prog(res_api);
                // if(res_api.schedule && res_api.schedule.events && res_api.schedule.events.length > 0) {
                //     this.movies = res_api.schedule.events;
                //     localStorage.setItem("events",JSON.stringify(this.movies))
                // }
            }catch(err){
                Overlay.hide();
                Swal.fire({
                    icon:"warning",
                    title:"Récupération de la programmation",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    window.location.replace("#home");
                });
                return;
            }
        }
        // console.log("$program_cine_block", iParam)

        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_config = data.config;

        const block_title = block_config ? block_config.title : _l("Programmation");

        var $wrap = $("<div/>").addClass("wrap").appendTo(iParam.$parent);
            var $title=$("<div/>").addClass("title").text(block_title).appendTo($wrap);
            
        if(!block_config || block_config.view_mode == "day"){
            $wrap.attr({"id":"wrap_program_cine_by_day"});
            var $flex=$("<div/>").addClass("d-flex flex-column flex-lg-row justify-content-center wrap_tools_prog").appendTo($wrap);
                var $container=$("<div/>").addClass("").attr({"id":"container_calendar_date"}).appendTo($flex);
                    var $wrap_slider=$("<div/>").addClass("d-flex flex-column").attr({"id":"wrap_slider_date"}).appendTo($container);
                var $container=$("<div/>").addClass("d-flex justify-content-center").attr({"id":"container_tools_date"}).appendTo($flex);
                    var $wrap_btn_calendar=$("<div/>").addClass("d-flex flex-column mx-1").attr({"id":"wrap_btn_calendar"}).appendTo($container);
                    var $wrap_btn_filter=$("<div/>").addClass("d-flex flex-column mx-1").attr({"id":"wrap_btn_filter"}).appendTo($container);
            var $flex=$("<div/>").addClass("d-flex flex-column").attr({"id":"wrap_prog_selected_date"}).appendTo($wrap);

            this.$create_slider_calendar({
                "first_day" : moment(),
            });
        }else if(block_config.view_mode == "week"){
            $wrap.attr({"id":"wrap_program_cine_by_week"});
            // On récupère les dates des semaines où il y a de la prog
            this.scheduled_weeks = this.m_prog.getScheduledWeeks({});

            if(this.scheduled_weeks.length <= 0){
                return;
            }

            var $flex=$("<div/>").addClass("mx-2 wrap_tools_prog_week").appendTo($wrap);
            // On crée un sélecteur avec ces dates
            let opt_week = {};
            this.scheduled_weeks.forEach(week => {
                opt_week[week.from] = _l("Du "+moment(week.from).format("DD/MM")+ " au "+moment(week.to).format("DD/MM"))
            });
            let fields = [];
            fields.push(
                [   
                    {
                        type: 'fl_select',
                        key: 'week_first_day',
                        cols: [12, 6, 4],
                        label: _l("Semaine"),
                        validation: {
                            required: true
                        },
                        options : opt_week,
                        class : "me-auto"
                    }
                ]
            );
            this.form_program_cine_by_week = new MSForm({
                fields : fields,
                bind_focus_out : false
            });
            this.form_program_cine_by_week.$create().appendTo($flex);
            this.form_program_cine_by_week.on("change",(e) => {
                let form_data = this.form_program_cine_by_week.getValue();

                if($(e.currentTarget).attr("key") == "week_first_day") {
                    this.$prog_cine_by_week({
                        "first_day" : form_data.week_first_day
                    });
                }
            });

            var $flex=$("<div/>").addClass("d-flex flex-column").attr({"id":"wrap_prog_selected_week"}).appendTo($wrap);

            this.$prog_cine_by_week({
                "first_day" : this.scheduled_weeks[0].from
            });
        }
    }

    async $search_bar_cinema_block(iParam){
        // console.log("PageCustom - $search_bar_cinema_block", iParam);

        if(gl_config.type == "site"){
            return;
        }

        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;

        var $wrap=$("<div/>").addClass("wra").attr({"id":"wrap_search_bar_cinema"});

        if(this.has_banner_image){
            this.find_banner_color();
            $("#block_"+iBlock.id+"_"+block_index).remove();
            if(is_on_mobile()){
                $wrap.appendTo($(".mobile-hero-builder"));
            }else{
                $wrap.appendTo($(".hero-builder"));
            }
            $wrap.addClass("inner_hero")
        }else{
            $wrap.appendTo(iParam.$parent);
        }

        let text_input = this.num_cine_selected && this.num_cine_selected != "null" ? (gl_config.chain.sites.filter(site => site.id == this.num_cine_selected)[0].name + " - " + gl_config.chain.sites.filter(site => site.id == this.num_cine_selected)[0].address.city) : _l("Sélectionnez votre cinéma");

        var $row=$("<div/>").addClass("row").attr({"id":"row_selected_site"}).appendTo($wrap);
            var $col=$("<div/>").addClass("col-10 col-md-8 col-lg-6 mx-auto").attr({"id":"col_selected_site"}).appendTo($row);
                var $div_dropdown=$("<div/>").addClass("d-flex dropdown-toggle position-relative").attr({"type":"button", "data-bs-toggle":"dropdown", "data-bs-auto-close":"outside", "aria-expanded":false}).appendTo($col);
                    var $text=$("<span/>").attr({"id":"text_selected"}).text(text_input).appendTo($div_dropdown);
                    let $svg_container = $("<div/>").addClass("icon_svg ms-auto").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_chevron_down")[0].svg_text).appendTo($div_dropdown);

        var $html_content = $("<div/>").addClass("px-1");
            var $ul=$("<ul/>").addClass("list-unstyled").attr({"id":"list_cinemas"}).appendTo($html_content);
                // Zone de recherche dans la liste des cinémas
                var $li=$("<li/>").addClass("d-flex").appendTo($ul);
                    var $form=$("<div/>").addClass("form-floating flex-1 my-1 my-md-0").appendTo($li);
                        var $input=$("<input/>").addClass("form-control ").attr({"type":"text","id":"input_search_cinema","name":"search_cinema","placeholder":_l("Chercher un cinéma")}).appendTo($form).on("paste keyup",(e) => {
                            let text_to_search = $(e.currentTarget).val().toLowerCase();
                            $("#col_selected_site #list_cinemas .li_cinemas").each((k,v) => {
                                let $elem = $(v);
                                $elem.hide();
                                const data_li = $elem.data("data").toLowerCase();
                                if(data_li.indexOf(text_to_search) >= 0){
                                    $elem.show();
                                }
                            })
                        })
                        var $label=$("<label/>").addClass("").attr({"for":"input_search_cinema"}).text(_l("Chercher un cinéma")).appendTo($form);
                // Tous les cinémas
                var $li=$("<li/>").addClass("d-flex").appendTo($ul).on("click",() => {
                    if(this.num_cine_selected && this.num_cine_selected != "null"){
                        this.num_cine_selected = null;
                        localStorage.setItem("chain_num_cine_selected", this.num_cine_selected);
                        this.init_page();
                    }
                });
                    var $name_site=$("<span/>").addClass("bold").text(_l("Tous les cinémas")).appendTo($li);
            gl_config.chain.sites.forEach(site => {
                var $li=$("<li/>").addClass("li_cinemas").data({"data" : site.name + " " +  site?.address?.city + " " + site?.address?.zip_code.substring(0,2)}).appendTo($ul).on("click",() => {
                    if(this.num_cine_selected != site.id){
                        this.num_cine_selected = site.id;
                        localStorage.setItem("chain_num_cine_selected", this.num_cine_selected)
                        this.init_page();
                    }
                });
                    var $flexbox=$("<div/>").addClass("d-flex").appendTo($li)
                        var $name_site=$("<span/>").addClass("bold").text(site.name).appendTo($flexbox);
                        var $city_site=$("<span/>").addClass("ms-1 mt-auto font-0_9").text(site?.address?.city).appendTo($flexbox);
                        var $zip_code_site=$("<span/>").addClass("ms-1 mt-auto font-0_9").text("("+site?.address?.zip_code.substring(0,2)+")").appendTo($flexbox);
            });

        MSDropDown.create({
            id: "chain_cinema",
            items: [$html_content],
            class : "w-100"
        }).appendTo($col); 
    }

    $separation_block(iParam) {
        const iBlock = iParam.block;
        var $wrap=$("<div/>").addClass("wrap").attr({"id":"wrap_separator"}).appendTo(iParam.$parent);

        if(iBlock.data && iBlock.data.config && iBlock.data.config.height){
            $wrap.css({
                "border-top": iBlock.data.config.height+"px solid"
            })
        }
    }

    async $slider_block(iParam) {
        // console.log("PageCustom - $slider_block", iBlock);
        // console.log(this.prog_cine)
        // console.log(this.chain_events)
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
                
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;

        var $wrap=$("<div/>").addClass("wrap").appendTo(iParam.$parent);
            var $title=$("<h2/>").addClass("title").text(_l(data.config.title)).appendTo($wrap);

        switch(data.config.type){
            case "custom":
                let tab_media_api = [];
                let tab_file_api = [];
                data.config.medias.forEach(media => {
                    tab_media_api.push("media_"+media);
                    if(media.link && media.link.type == "file"){
                        tab_file_api.push("file_"+media.link.file_id);
                    }
                });

                // Appel API récupération config des médias du slider
                let res_api_media;
                let res_api_file;
                try{
                    res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
                    // console.log("Result get_website_docs media",res_api_media)
                    if(!res_api_media.docs) {
                        Swal.fire({
                            icon:"warning",
                            title:"Récupération config des médias du slider "+data.label,
                            showCloseButton : true,
                            text: _l("Echec de la récupération"),
                            heightAuto : false,
                            scrollbarPadding : false,
                            allowOutsideClick : false,
                            customClass: {
                                icon : "align-items-center"
                            }
                        });
                    }

                    // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
                    Object.values(res_api_media.docs).forEach(media => {
                        if(media.link && media.link.type == "file"){
                            tab_file_api.push("file_"+media.link.file_id);
                        }
                    });

                    if(tab_file_api.length > 0){
                        res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                        Object.values(res_api_file.docs).forEach(file => {
                            // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                            if(this.list_files.filter(f => f.id == file.id) <=0 ){
                                this.list_files.push(file);
                            }
                        });
                    }
                    // console.log("Result get_website_docs files",res_api_file)

                }catch(err){
                    Overlay.hide();
                    Swal.fire({
                        icon:"warning",
                        title:"Récupération config des médias du slider "+data.label,
                        showCloseButton : true,
                        text: _l(err.data ? err.data.message : err),
                        heightAuto : false,
                        scrollbarPadding : false,
                        allowOutsideClick : false,
                        customClass: {
                            icon : "align-items-center"
                        }
                    }).then((result) => {
                        // window.location.replace("#home");
                    });
                    // return;
                }

                const custom_slider = new SliderBuilder();
                const $slider_custom = custom_slider.$create().appendTo($wrap);
                custom_slider.$createCustomCards({
                    "data" : Object.values(res_api_media.docs),
                    "$parent" : $wrap,
                    "class_from" : this
                });
                break;
            case "current_week_movies":
                const slider_current_week = new SliderBuilder({
                    "website_config":gl_config
                });
                const $slider_current_week = slider_current_week.$create().appendTo($wrap);
                slider_current_week.$filterCurrentWeekMovies({"events":this.prog_cine, "num_cine": this.num_cine_selected, "$parent":$wrap});
                break;
            case "next_week_movies":
                const slider_next_week = new SliderBuilder({
                    "website_config":gl_config
                });
                const $slider_next_week = slider_next_week.$create().appendTo($wrap);
                slider_next_week.$filterNextWeekEvents(this.prog_cine);
                break;
            case "shortly_movies":
                const slider_shortly_movies = new SliderBuilder({
                    "website_config":gl_config
                });
                const $slider_shortly_movies = slider_shortly_movies.$create().appendTo($wrap);
                slider_shortly_movies.$filterShortlyMovies({"events":this.prog_cine, "num_cine": this.num_cine_selected, "$parent":$wrap});
                break;
            default:
                var movies_list = await this.m_prog.filter_events({
                    "categorie" : data.config.type,
                    "num_cine_selected" : this.num_cine_selected,
                    "website_type" : gl_config.type,
                    "data" : data
                });

                if(movies_list.length <= 0){
                    iParam.$parent.remove();
                    return;
                }
                const slider = new SliderBuilder({
                    "website_config":gl_config
                });
                const $slider = slider.$create().appendTo($wrap);
                if(data.config.type == "superbillet"){
                    slider.$createSessionCards(movies_list);
                }else{
                    slider.$createEventsCards(movies_list);
                }
                break;
        }
    }

    $simple_text_block(iParam) {
        // console.log("PageCustom - $simple_text_block", iBlock);
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        var $wrap=$("<div/>").addClass("wrap wrap_media").appendTo(iParam.$parent);
            var $editor=$("<div/>").addClass("editor").attr({"id":"editor_"+iBlock.id+"_"+data.label+"_"+block_index}).appendTo($wrap);

        this["quill_"+iBlock.id+"_"+data.label+"_"+block_index] = new Quill("#editor_"+iBlock.id+"_"+data.label+"_"+block_index, {
            theme: ''
        });
        this["quill_"+iBlock.id+"_"+data.label+"_"+block_index].setContents(data.text); // Overwrites editor with given contents
        this["quill_"+iBlock.id+"_"+data.label+"_"+block_index].enable(false); // Set ability for user to edit
    }

    async $text_image_block(iParam) {
        // console.log("PageCustom - $text_image_block", iParam);
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }
        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        let tab_media_api = [];
        let tab_file_api = [];
        // Appel API récupération config des médias du slider
        let res_api_media;
        let res_api_file;
        data.config.medias.forEach(media => {
            tab_media_api.push("media_"+media);
        });
        try{
            res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
            // console.log("Result get_website_docs media",res_api_media)
            if(!res_api_media.docs) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config des médias du slider "+data.label,
                    showCloseButton : true,
                    text: _l("Echec de la récupération"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                });
            }

            // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
            Object.values(res_api_media.docs).forEach(media => {
                if(media.link && media.link.type == "file"){
                    tab_file_api.push("file_"+media.link.file_id);
                }
            });

            if(tab_file_api.length > 0){
                res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                Object.values(res_api_file.docs).forEach(file => {
                    // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                    if(this.list_files.filter(f => f.id == file.id) <=0 ){
                        this.list_files.push(file);
                    }
                });
            }
            // console.log("Result get_website_docs files",res_api_file)

        }catch(err){
            Overlay.hide();
            Swal.fire({
                icon:"warning",
                title:"Récupération config des médias du slider "+data.label,
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                // window.location.replace("#home");
            });
            // return;
        }
        var media = Object.values(res_api_media.docs)[0]
        media.media_url = media.media_url.replace("/120x","/1920x");
        media.media_url = media.media_url.replace("/600x","/1920x");
        media.media_url = media.media_url.replace("/320","/1920");
        media.media_url = media.media_url.replace("/600","/1920");

        // Gestion des dates de validité d'affichage du media
        if(media.validity && media.validity.type == "date"){
            var from = media.validity.from;
            var to = media.validity.to;
            if(from > this.today || to < this.today){
                return;
            }
        }

        var $wrap=$("<div/>").addClass("wrap wrap_media").appendTo(iParam.$parent);
            var $row=$("<div/>").addClass("row d-flex").appendTo($wrap);
                var $col_image=$("<div/>").addClass("").appendTo($row);
                    var $poster_container=$("<div/>").addClass("poster_container mx-auto").appendTo($col_image);
                    var $img=$("<img/>").addClass("poster media_image").attr({"src":media.media_url, "alt":""}).appendTo($poster_container);
                        if(media.description){
                            var $flexbox=$("<div/>").addClass("box_details").appendTo($poster_container);
                                var $description=$("<div/>").addClass("description_img m-auto").text(media.description).appendTo($flexbox);
                        }
                var $col_text=$("<div/>").addClass("my-1 my-md-0").appendTo($row);
                    var $editor=$("<div/>").addClass("editor").attr({"id":"editor_"+iBlock.id+"_"+data.label+"_"+block_index}).appendTo($col_text);
                    this["quill_"+iBlock.id+"_"+data.label+"_"+block_index] = new Quill("#editor_"+iBlock.id+"_"+data.label+"_"+block_index, {
                        theme: ''
                    });
                    this["quill_"+iBlock.id+"_"+data.label+"_"+block_index].setContents(data.config.text); // Overwrites editor with given contents
                    this["quill_"+iBlock.id+"_"+data.label+"_"+block_index].enable(false); // Set ability for user to edit

        if(media.link && media.link != "none"){
            $img.addClass("pointer");
        }

        $img.on("click", function (e) {
            e.preventDefault();
            self.set_media_action(media)
        });

        switch(data.config.disposition){
            case "text_left":
                if(!is_on_mobile()){
                    $col_text.css({"order":1});
                    $col_image.css({"order":2});
                }
                switch(data.config.proportion){
                    case "1_3":
                        $col_text.addClass("col-12 col-md-4");
                        $col_image.addClass("col-12 col-md-8");
                        break;
                    case "1_2":
                        $col_text.addClass("col-12 col-md-6");
                        $col_image.addClass("col-12 col-md-6");
                        break;
                    case "2_3":
                        $col_text.addClass("col-12 col-md-8");
                        $col_image.addClass("col-12 col-md-4");
                        break;
                    default:
                        break
                }
                break;
            case "text_right":
                if(!is_on_mobile()){
                    $col_text.css({"order":2});
                    $col_image.css({"order":1});
                }
                switch(data.config.proportion){
                    case "1_3":
                        $col_image.addClass("col-12 col-md-4");
                        $col_text.addClass("col-12 col-md-8");
                        break;
                    case "1_2":
                        $col_image.addClass("col-12 col-md-6");
                        $col_text.addClass("col-12 col-md-6");
                        break;
                    case "2_3":
                        $col_image.addClass("col-12 col-md-8");
                        $col_text.addClass("col-12 col-md-4");
                        break;
                    default:
                        break
                }
                break;
            case "text_top":
                $col_text.addClass("col-12").css({"order":1});
                $col_image.addClass("col-12").css({"order":2});
                break;
            case "text_bottom":
                $col_text.addClass("col-12").css({"order":2});
                $col_image.addClass("col-12").css({"order":1});
                break;
            default:
                break;
        }
    }

    async $text_video_block(iParam) {
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }
        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        let tab_media_api = [];
        let tab_file_api = [];
        // Appel API récupération config des médias du slider
        let res_api_media;
        let res_api_file;
        data.config.medias.forEach(media => {
            tab_media_api.push("media_"+media);
        });
        try{
            res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
            // console.log("Result get_website_docs media",res_api_media)
            if(!res_api_media.docs) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config des médias du slider "+data.label,
                    showCloseButton : true,
                    text: _l("Echec de la récupération"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                });
            }

            // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
            Object.values(res_api_media.docs).forEach(media => {
                if(media.link && media.link.type == "file"){
                    tab_file_api.push("file_"+media.link.file_id);
                }
            });

            if(tab_file_api.length > 0){
                res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                Object.values(res_api_file.docs).forEach(file => {
                    // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                    if(this.list_files.filter(f => f.id == file.id) <=0 ){
                        this.list_files.push(file);
                    }
                });
            }
            // console.log("Result get_website_docs files",res_api_file)

        }catch(err){
            Overlay.hide();
            Swal.fire({
                icon:"warning",
                title:"Récupération config des médias du slider "+data.label,
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                // window.location.replace("#home");
            });
            // return;
        }
        var media = Object.values(res_api_media.docs)[0]
        media.media_url = media.media_url.replace("/ld","/hd");
        media.thumbnail_url = media.thumbnail_url.replace("/120x","/1920x");
        media.thumbnail_url = media.thumbnail_url.replace("/600x","/1920x");
        media.thumbnail_url = media.thumbnail_url.replace("/320","/1920");
        media.thumbnail_url = media.thumbnail_url.replace("/600","/1920");

        // Gestion des dates de validité d'affichage du media
        if(media.validity && media.validity.type == "date"){
            var from = media.validity.from;
            var to = media.validity.to;
            if(from > this.today || to < this.today){
                return;
            }
        }

        // Gestion des boutons de controls de la vidéo
        let has_controls = true;
        if(is_on_mobile() && media.link && media.link.type != "none"){
            has_controls = false;
        }

        var $wrap=$("<div/>").addClass("wrap wrap_media").appendTo(iParam.$parent);
            var $row=$("<div/>").addClass("row d-flex").appendTo($wrap);
                var $col_image=$("<div/>").addClass("").appendTo($row);
                    var $poster_container=$("<div/>").addClass("poster_container w-100").appendTo($col_image);
                        var $media=$("<video/>").addClass("img_media m-auto").attr({"src":media.media_url, "controls":has_controls, "controlslist":"nofullscreen", "poster":media.thumbnail_url, "id":"video_id_"+media.id, "webkit-playsinline":"", "playsinline":"", "loop":""}).appendTo($poster_container);
                            if(media.description){
                                var $flexbox=$("<div/>").addClass("box_details").appendTo($poster_container);
                                    var $description=$("<div/>").addClass("description_img m-auto").text(media.description).appendTo($flexbox);
                            }
                var $col_text=$("<div/>").addClass("my-1 my-md-0").appendTo($row);
                    var $editor=$("<div/>").addClass("editor").attr({"id":"editor_"+iBlock.id+"_"+data.label+"_"+block_index}).appendTo($col_text);
                    this["quill_"+iBlock.id+"_"+data.label+"_"+block_index] = new Quill("#editor_"+iBlock.id+"_"+data.label+"_"+block_index, {
                        theme: ''
                    });
                    this["quill_"+iBlock.id+"_"+data.label+"_"+block_index].setContents(data.config.text); // Overwrites editor with given contents
                    this["quill_"+iBlock.id+"_"+data.label+"_"+block_index].enable(false); // Set ability for user to edit

        if(media.link && media.link.type!= "none"){
            // $img.addClass("pointer");
            $media.addClass("pointer");
        }

        // $img.on("click", function (e) {
        $media.on("click", function (e) {
            e.preventDefault();
            self.set_media_action(media)
        });

        switch(data.config.disposition){
            case "text_left":
                if(!is_on_mobile()){
                    $col_text.css({"order":1});
                    $col_image.css({"order":2});
                }
                switch(data.config.proportion){
                    case "1_3":
                        $col_text.addClass("col-12 col-md-4");
                        $col_image.addClass("col-12 col-md-8");
                        break;
                    case "1_2":
                        $col_text.addClass("col-12 col-md-6");
                        $col_image.addClass("col-12 col-md-6");
                        break;
                    case "2_3":
                        $col_text.addClass("col-12 col-md-8");
                        $col_image.addClass("col-12 col-md-4");
                        break;
                    default:
                        break
                }
                break;
            case "text_right":
                if(!is_on_mobile()){
                    $col_text.css({"order":2});
                    $col_image.css({"order":1});
                }
                switch(data.config.proportion){
                    case "1_3":
                        $col_image.addClass("col-12 col-md-4");
                        $col_text.addClass("col-12 col-md-8");
                        break;
                    case "1_2":
                        $col_image.addClass("col-12 col-md-6");
                        $col_text.addClass("col-12 col-md-6");
                        break;
                    case "2_3":
                        $col_image.addClass("col-12 col-md-8");
                        $col_text.addClass("col-12 col-md-4");
                        break;
                    default:
                        break
                }
                break;
            case "text_top":
                $col_text.addClass("col-12").css({"order":1});
                $col_image.addClass("col-12").css({"order":2});
                break;
            case "text_bottom":
                $col_text.addClass("col-12").css({"order":2});
                $col_image.addClass("col-12").css({"order":1});
                break;
            default:
                break;
        }

        $media.prop("muted",true);
        $media[0].play();
        this.list_$video_playing.push($media);
    }

    async $video_block(iParam) {
        // console.log("PageCustom - $video_block", iParam);
        if(gl_config.type == "site" && !this.m_prog){
            try {
                const res_api = await gl_api.getProg();
                this.m_prog = new Prog(res_api);
                this.prog_cine = res_api.schedule.events;
            } catch (err) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config de la page",
                    showCloseButton : true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                }).then((result) => {
                    // window.location.replace("#home");
                });
            }
        }
        const self = this;
        const iBlock = iParam.block;
        const data = iBlock.data;
        const block_index = iParam.index;
        let tab_media_api = [];
        let tab_file_api = [];
        data.config.medias.forEach(media => {
            tab_media_api.push("media_"+media);
        });
        // Appel API récupération config des médias du slider
        let res_api_media;
        let res_api_file;
        try{
            res_api_media = await gl_api.get_website_docs({"docs" : tab_media_api});
            // console.log("Result get_website_docs media",res_api_media)
            if(!res_api_media.docs) {
                Swal.fire({
                    icon:"warning",
                    title:"Récupération config des médias du slider "+data.label,
                    showCloseButton : true,
                    text: _l("Echec de la récupération"),
                    heightAuto : false,
                    scrollbarPadding : false,
                    allowOutsideClick : false,
                    customClass: {
                        icon : "align-items-center"
                    }
                });
            }

            // Si les médias ont des fichiers de téléchargement associés au clic, on va chercher leurs config
            Object.values(res_api_media.docs).forEach(media => {
                if(media.link && media.link.type == "file"){
                    tab_file_api.push("file_"+media.link.file_id);
                }
            });

            if(tab_file_api.length > 0){
                res_api_file = await gl_api.get_website_docs({"docs" : tab_file_api});
                Object.values(res_api_file.docs).forEach(file => {
                    // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                    if(this.list_files.filter(f => f.id == file.id) <=0 ){
                        this.list_files.push(file);
                    }
                });
            }
            // console.log("Result get_website_docs files",res_api_file)

        }catch(err){
            Overlay.hide();
            Swal.fire({
                icon:"warning",
                title:"Récupération config des médias du slider "+data.label,
                showCloseButton : true,
                text: _l(err.data ? err.data.message : err),
                heightAuto : false,
                scrollbarPadding : false,
                allowOutsideClick : false,
                customClass: {
                    icon : "align-items-center"
                }
            }).then((result) => {
                // window.location.replace("#home");
            });
            // return;
        }
        var media = Object.values(res_api_media.docs)[0]
        media.media_url = media.media_url.replace("/ld","/hd");
        media.thumbnail_url = media.thumbnail_url.replace("/120x","/1920px");
        media.thumbnail_url = media.thumbnail_url.replace("/600x","/1920px");
        media.thumbnail_url = media.thumbnail_url.replace("/320","/1920");
        media.thumbnail_url = media.thumbnail_url.replace("/600","/1920");

        // Gestion des dates de validité d'affichage du media
        if(media.validity && media.validity.type == "date"){
            var from = media.validity.from;
            var to = media.validity.to;
            if(from > this.today || to < this.today){
                return;
            }
        }

        // Gestion des boutons de controls de la vidéo
        let has_controls = true;
        if(is_on_mobile() && media.link && media.link.type != "none"){
            has_controls = false;
        }

        var $wrap=$("<div/>").addClass("wrap wrap_media").appendTo(iParam.$parent);
            var $row=$("<div/>").addClass("row").appendTo($wrap);
                var $col=$("<div/>").addClass("col-12 d-flex").appendTo($row);
                    var $poster_container=$("<div/>").addClass("poster_container w-100").appendTo($col);
                        var $media=$("<video/>").addClass("img_media m-auto").attr({"src":media.media_url, "controls":has_controls, "controlslist":"nofullscreen", "poster":media.thumbnail_url, "id":"video_id_"+media.id, "webkit-playsinline":"", "playsinline":"", "loop":""}).appendTo($poster_container);
                        if(media.description){
                            var $flexbox=$("<div/>").addClass("box_details").appendTo($poster_container);
                                var $description=$("<div/>").addClass("description_img m-auto").text(media.description).appendTo($flexbox);
                        }

        if(media.link && media.link.type != "none"){
            // $img.addClass("pointer");
            $media.addClass("pointer");
        }

        // $img.on("click", function (e) {
        $media.on("click", function (e) {
            e.preventDefault();
            self.set_media_action(media)
        });

        $media.prop("muted",true);
        $media[0].play();
        this.list_$video_playing.push($media);
    }

    

    $create_slider_calendar(iParam) {
        $("#pane_page_custom_"+this.page_id+" #wrap_slider_date").empty();

        this.m_prog.$calendar_prog({
            "first_day" : iParam.first_day,
            "$parent" : $("#pane_page_custom_"+this.page_id+" #wrap_slider_date"),
            "id" : "#pane_page_custom_"+this.page_id,
            "action" : (date) => {this.display_movies_selected_date(date)},
            "movie_id" : null,
            "callback": (cb) => {
                if(cb.common_features){
                    this.$create_btn_filter_prog({
                        "features" : cb.common_features
                    })
                }
            }
        });
    }

    $create_btn_filter_prog(iParam) {
        $("#pane_page_custom_"+this.page_id+" #wrap_btn_filter").empty();
    
        const uniqueFeatures = this.removeDuplicates(iParam.features);
    
        this.m_prog.$btn_filter_prog({
            "id": "pane_page_custom_"+this.page_id+"_filter_prog",
            "features": uniqueFeatures, 
            "$parent": $("#pane_page_custom_"+this.page_id+" #wrap_btn_filter"),
            "onSelect": (features) => {
                this.selected_features_filter_prog = features;
                this.apply_filter_prog();
            }
        });   
    }

    removeDuplicates(array) {
        return [...new Set(array)];
    }

    apply_filter_prog() {
        let filters = this.selected_features_filter_prog;
        let at_least_one = false;

        $("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_day #text_empty_filter").remove();

        // Traitement des items(journée) du calendrier
        // On va regarder si les séances de la journée correspondent aux filtres 
        // Si ce n'est pas le cas on grisera l'élément
        $("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_day .slider_date .slider-item").each((i,e) => {
            let $item = $(e);
            if(!$item.hasClass("no_prog")){
                $item.removeClass("disabled");
            }
            let date_item = $item.data("date");
            let list_events = this.m_prog.get_events_by_features({
                "date" : date_item,
                "features" : filters
            });

            if(filters.length > 0 && list_events.length <= 0){
                $item.addClass("disabled")
            }
        });

        if (filters.length <= 0) {
            $("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_day .row_movie").show().addClass("d-flex");
            return;
        }

        $("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_day .row_movie").each((i,e) => {
            let find = false;
            $(e).find(".movie_features_container .features").each((i,e) => {
                if(filters.includes($(e).attr("alt"))){
                    find = true;
                    return;
                }
            });

            $(e).find(".session_features_container .features").each((i,e) => {
                if(filters.includes($(e).attr("alt"))){
                    find = true;
                    return;
                }
            });

            if(find){
                at_least_one = true;
                $(e).show();
                $(e).addClass("d-flex")
            }else{
                $(e).removeClass("d-flex");
                $(e).hide();
            }
        });

        if(!at_least_one){
            $("<div/>").addClass("text-center my-3 bold font-1_25").attr({"id":"text_empty_filter"}).text(_l("Pas de séance à cette date avec votre filtre")).appendTo($("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_day"));
        }
    }

    display_movies_selected_date(iDate){
        this.max_height_wrap_prog_selected_date = 0;
        const allMoviesTodisplay = this.m_prog.getAllMoviesSelectedDate(iDate,null);
        $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").empty();

        if(allMoviesTodisplay.length <= 0 ){
            var $text=$("<h4/>").addClass("text-center my-3 my-md-5").text(_l("Pas de séance le "+moment(iDate).format("DD MMM YYYY"))).appendTo($("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date"))
        }

        let common_features = [];
        let common_custom_tags = [];

        allMoviesTodisplay.forEach((movie, index) => {
            let event = movie;
            let sessions = movie.sessions;

            if(index > 3){
                $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").addClass("reduced_display");
                if(index == 4){
                    // Ajout de la flèche pour ouvrir le reste de la prog
                    if($("#pane_page_custom_"+this.page_id+" #row_reduced_display").length > 0){
                        return;
                    }
                    var $row=$("<div/>").addClass("row py-2").attr({"id":"row_reduced_display"}).appendTo($("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_day"));
                        var $col=$("<div/>").addClass("col-12 pointer text-center").appendTo($row).on("click",() => {
                            if($("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").hasClass("reduced_display")){
                                $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").removeClass("reduced_display");
                                $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").css({
                                    "max-height" : "100%"
                                });
                                $("#pane_page_custom_"+this.page_id+" #row_reduced_display .text")[0].textContent = _l("Voir moins de film");
                                $("#pane_page_custom_"+this.page_id+" #row_reduced_display .icon#icon_chevron_up").show();
                                $("#pane_page_custom_"+this.page_id+" #row_reduced_display .icon#icon_chevron_down").hide();
                            }else{
                                $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").addClass("reduced_display");
                                $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").css({
                                    "max-height" : this.max_height_wrap_prog_selected_date
                                });
                                $("#pane_page_custom_"+this.page_id+" #row_reduced_display .text")[0].textContent = _l("Voir plus de film");
                                $("#pane_page_custom_"+this.page_id+" #row_reduced_display .icon#icon_chevron_up").hide();
                                $("#pane_page_custom_"+this.page_id+" #row_reduced_display .icon#icon_chevron_down").show();
                            }
                        });
                            var $text=$("<div/>").addClass("mb-1 text bold").text(_l("Voir plus de film")).appendTo($col);
                            let $svg_container = $("<div/>").addClass("icon icon_svg mx-auto").attr({"id":"icon_chevron_down"}).html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_chevron_down")[0].svg_text).appendTo($col);
                            let $svg_container_1 = $("<div/>").addClass("icon icon_svg mx-auto").attr({"id":"icon_chevron_up"}).html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_chevron_up")[0].svg_text).appendTo($col).hide();

                    // on va prendre la taille actuelle de l'élément pour définir le max-height
                    this.max_height_wrap_prog_selected_date = $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").height();
                    $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").css({
                        "max-height" : this.max_height_wrap_prog_selected_date
                    });
                }
            }else{
                if($(" #row_reduced_display").length > 0){
                    $("#pane_page_custom_"+this.page_id+" #row_reduced_display").remove();
                    $("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date").css({
                        "max-height" : "100%"
                    });
                }
            }

            var $row=$("<div/>").addClass("row py-3 row_movie").appendTo($("#pane_page_custom_"+this.page_id+" #wrap_prog_selected_date"));
                var $col=$("<div/>").addClass("col-12 col-md-4 movie_info_container pointer").appendTo($row).on("click",() => {
                    window.location.href = `#showmovie?id=${event.id}`;
                    location.reload();
                });
                    var $flexbox=$("<div/>").addClass("d-flex flex-wrap").appendTo($col);
                        var $movie_title=$("<div/>").addClass("movie_title my-auto px-2 px-md-3").text(event.title).appendTo($flexbox);
                        // Certification
                        if(event.certification && event.certification.img){
                            var $img_certification=$("<img/>").addClass("img_certification my-auto").attr({"src":event.certification.img, "loading":"lazy", "alt":""}).appendTo($flexbox);
                        }
                    // Common Features
                    var $movie_features_container=$("<div/>").addClass("movie_features_container px-2 px-md-3 pt-2 pb-2 pb-md-0").appendTo($col);
                    if(event.art_et_essai_actif){
                        if(!event.features){
                            event.features = [];
                        }
                        if(event.features.indexOf("art_et_essai")<0){
                            event.features.push("art_et_essai");
                        }
                        // event.features.push("art_et_essai");
                    }
                    event.features.forEach(feature => {
                        if(feature=="headline"){
                            return;
                        }
                        let feature_url = "https://static.monnaie-services.com/www-img/session/features/"+feature+".png";
                        switch(feature){
                            default:
                                var $img=$("<img/>").addClass("features my-auto").attr({"src":feature_url, "title":_l('#session_feature_'+feature) , "alt":feature, "loading":"lazy"}).appendTo($movie_features_container);
                                break;
                        }

                        if(common_features.indexOf(feature) < 0){
                            common_features.push(feature)
                        }
                    });

                    // Common custom tags
                    if(event.custom_tags){
                        var $movie_custom_tags_container=$("<div/>").addClass("movie_custom_tags_container px-2 px-md-3 pt-2 pb-2 pb-md-0").appendTo($col);
                        event.custom_tags.forEach(tag_id => {
                            const data_tag = gl_custom_prog_tags[tag_id];
                            if(!data_tag){
                                return;
                            }
                            var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($movie_custom_tags_container);

                            if(common_custom_tags.indexOf(tag_id) < 0){
                                common_custom_tags.push(tag_id)
                            }
                        });
                    };

                var $col=$("<div/>").addClass("col-12 col-md-8 d-flex justify-content-around justify-content-md-start").appendTo($row);
                    var $session_container=$("<div/>").addClass("d-flex flex-wrap justify-content-around justify-content-md-start my-auto session_container").appendTo($col);
                    sessions.forEach(session => {
                        const session_id = session.ems && session.ems.id ? session.ems.id : session.id;
                        var $wrap_session=$("<div/>").addClass("wrap_session").appendTo($session_container).on("click",() => {
                            // console.log(session)
                            window.location.href = "#showsession?id="+session.id;
                        });
                            var $session=$("<div/>").addClass("session_block d-flex flex-column").appendTo($wrap_session)
                                var $hour=$("<div/>").addClass("m-auto session_hour").text(session.date.substring(8,10)+"h"+session.date.substring(10,12)).appendTo($session);

                                if(gl_ems_config.data_cinema.show_halls) {
                                    var $hall=$("<div/>").addClass("hall info").text(session.hall_name).appendTo($session);
                                }

                                if(gl_ems_config && gl_ems_config.data_cinema && gl_ems_config.data_cinema.show_availability) {
                                    var $wrap=$("<div/>").addClass("d-flex wrap_availability justify-content-center wrap_availability_session_id_"+session_id).appendTo($session);
                                        $("<div/>").addClass("nb_availability_session_id_"+session_id).appendTo($wrap);
                                        $("<div/>").addClass("text ms-1").text(_l("Place(s)")).appendTo($wrap);
                                }

                                if(session.headline){
                                    var $ct_icon_headline=$("<div/>").addClass("ct_headline position-absolute").appendTo($session);
                                        var $icon_headline=$("<i/>").addClass("fas fa-plus icon_headline m-auto").appendTo($ct_icon_headline);
                                            var $tooltip_content=$("<div/>").addClass("d-none").appendTo($icon_headline);
                                                var $text=$("<div/>").addClass("p-2 m-auto bold box-radius").text(session.headline).appendTo($tooltip_content);
                                        $icon_headline.tooltip({
                                            html:true,
                                            title:$tooltip_content.html()
                                        });
                                }

                                if(!session.booking_url){
                                    // $wrap_session.off("click");
                                    // $session.addClass("disabled")
                                }

                            var $session_features_container=$("<div/>").addClass("session_features_container").appendTo($wrap_session);
                            session.features.forEach(feature => {
                                // if(feature=="vf" || feature=="headline" || $.inArray(feature,event.features)>=0){
                                if(feature=="headline" || $.inArray(feature,event.features)>=0){
                                    return;
                                }
                                let feature_url = "https://static.monnaie-services.com/www-img/session/features/"+feature+".png";
                                switch(feature){
                                    default:
                                        var $img=$("<img/>").addClass("features mx-auto").attr({"src":feature_url, "title":_l('#session_feature_'+feature) , "alt":feature, "loading":"lazy"}).appendTo($session_features_container);
                                        break;
                                }

                                if(common_features.indexOf(feature) < 0){
                                    common_features.push(feature)
                                }
                            });

                            if(session.custom_tags){
                                var $session_custom_tags_container=$("<div/>").addClass("session_custom_tags_container").appendTo($session);
                                session.custom_tags.forEach(tag_id => {
                                    const data_tag = gl_custom_prog_tags[tag_id];
                                    if(!data_tag){
                                        return;
                                    }
                                    var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($session_custom_tags_container);

                                    if(common_custom_tags.indexOf(tag_id) < 0){
                                        common_custom_tags.push(tag_id)
                                    }
                                });
                            }
                    }); 

                var $col=$("<div/>").addClass("col-12").appendTo($row);
                    var $separator=$("<div/>").addClass("separator pt-2").appendTo($col);
        });     

        gl_app.maj_availability();  

        this.apply_filter_prog();
    }
   
    // Fonction appelée lors du click sur un media (depuis un slider, carousel, etc...)
    set_media_action(iMedia) {
        // console.log(iMedia)
        if(iMedia.link && iMedia.link.type != "none"){            
            switch(iMedia.link.type){
                case "external_url":
                    window.open(iMedia.link.external_url,"_blank")
                    break;
                case "file":
                    if(this.list_files){
                        let file_data = this.list_files.filter(file => file.id == iMedia.link.file_id)[0];
                        console.log(file_data)
                        console.log(this.list_files)
                        console.log(iMedia.link.file_id)
                        if(file_data){
                            const $link=$("<a/>").addClass("btn m-auto").attr({"id":"btn_download_file", "href":file_data.media_url, "download":file_data.name}).appendTo($("body"));
                            $("#btn_download_file").get(0).click();
                            $link.remove();
                        }
                    }
                    break;
                case "movie": 
                    window.location.href = "#showmovie?id="+iMedia.link.movie_id;
                    break
                case "page":
                    window.location.href = "#"+iMedia.link.page_id;
                    break;
                case "session": 
                    // Si le film est dans la prog, on redirige vers la page
                    const movie_data = this.prog_cine.filter(event => event.id == iMedia.link.movie_id)
                    if(movie_data.length > 0){
                        // Si la séance est dans la prog, on redirige vers la page
                        if(movie_data[0].sessions.filter(session => session.id == iMedia.link.session_id).length > 0){
                            window.location.href = "#showsession?id="+iMedia.link.session_id;
                        }
                    }
                    break;
                case "superbillet":
                    if(this.superbillet_cine.filter(sb => sb.id == iMedia.link.superbillet_id).length > 0){
                        window.location.href = "#showsuperbillet?id="+iMedia.link.superbillet_id;
                    }
                    break;
                case "zoom":
                    var $content=$("<div/>");
                        var $img=$("<img/>").attr({"src":iMedia.media_url}).addClass("w-100").appendTo($content);

                    this.modal_zoom_img = new MSModal({
                        buttons: [],
                        has_close_box: false,
                        html: $content,
                        option: {
                            dialog: {
                                class: "modal-dialog-centered modal-xl modal-dialog-scrollable modal_zoom_img"
                            },
                            title: {
                                class: "w-100 h3 text-center"
                            },
                            type: "show_movie_rating",
                            remove_footer : false
                        },
                        title: iMedia.title,
                    })
                    this.modal_zoom_img.open();
                    break;
                default:
                    break;
            }
        }
    }

    async find_banner_color() {
        if($("#pane_page_custom_"+this.page_id+" #hero-img").length > 0){
            // console.log($("#pane_page_custom_"+this.page_id+" #hero-img").attr("src"))
            const banner_url = $("#pane_page_custom_"+this.page_id+" #hero-img").attr("src");
            const colorThief = new ColorThief();
            const img = new Image();
            img.addEventListener('load', async() => {
                let rgb = colorThief.getColor(img);
                // console.log(rgb[0]+rgb[1]+rgb[2])
                // if(rgb[0]+rgb[1]+rgb[2]>350){
                $("nav").removeClass("black white");
                $(".hero-movie-title").removeClass("black white");
                $(".hero-side").removeClass("black white");
                $(".hero-builder").removeClass("black white");
                if(rgb[0]+rgb[1]+rgb[2]>500){
                    if(!gl_config.website.style || !gl_config.website.style.navbar_transparency || gl_config.website.style.navbar_transparency == "with"){
                        $("nav").addClass("black");
                    }
                    $(".hero-movie-title").addClass("black");
                    $(".hero-side").addClass("white");
                    $(".hero-builder").addClass("white");
                }else{
                    if(!gl_config.website.style || !gl_config.website.style.navbar_transparency || gl_config.website.style.navbar_transparency == "with"){
                        $("nav").addClass("white");
                    }
                    $(".hero-movie-title").addClass("white");
                    $(".hero-side").addClass("black");
                    $(".hero-builder").addClass("black");
                }
            });

            img.crossOrigin = 'Anonymous';
            img.src = banner_url;
        }
    }

    // Programme cinéma par semaine
    $prog_cine_by_week(iParam){
        // console.log("$prog_cine_by_week", iParam)

        if(!iParam && !iParam.first_day){
            return;
        }

        $("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_week #wrap_prog_selected_week").empty()

        // On veut la prog de la semaine cinématographique
        this.week_cine_prog = this.m_prog.get_week_cine_prog({
            "first_day" : moment(iParam.first_day)
        });
        // console.log(this.week_cine_prog);

        if(!this.week_cine_prog.events || this.week_cine_prog.events.length <= 0){
            return;
        }

        this.week_cine_prog.events.forEach(elem => {
            const movie = elem.event;
            // console.log(movie)
            movie.certification = this.m_prog.ParseCertification(movie.certification_id);
            movie.runtime = this.m_prog.timeConvert(movie.duration);
            var poster_url = movie.bill_url ? movie.bill_url : "https://static.monnaie-services.com/www-img/ticketingcine/no_poster_imsweb.webp";
            if(poster_url){
                if(is_on_mobile()){
                    poster_url = poster_url.replace("/120","/320");
                }else{
                    poster_url = poster_url.replace("/120","/600");
                }
            }

            var $movies_container=$("<div/>").addClass("movies-container d-flex flex-column").appendTo($("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_week #wrap_prog_selected_week"));
                var $flexbox=$("<div/>").addClass("d-flex flex-column flex-md-row mx-1 mx-md-2").appendTo($movies_container);
                    var $div=$("<div/>").addClass("mx-auto").appendTo($flexbox)
                        var $poster_container=$("<div/>").addClass("poster_container mb-auto me-2 pointer").appendTo($div).on("click",() => {
                            window.location.href = "#showmovie?id="+movie.id
                        });
                            var $poster=$("<img/>").addClass("poster bill-img").attr({"src":poster_url, "alt":movie.title}).appendTo($poster_container);
                            var $poster_header=$("<div/>").addClass("poster_header d-flex").appendTo($poster_container);
                            if(movie.certification && movie.certification.img){
                                var $img_certification=$("<img/>").addClass("img_certification my-auto").attr({"src":movie.certification.img, "alt":""}).appendTo($poster_header);
                            }
                            if(movie.trailer_url){
                                var $corner_fold=$("<div/>").addClass("bottom-left-corner-fold").appendTo($poster_container);
                                    let $svg_container = $("<div/>").addClass("svg_container icon icon_svg play-icon").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_circle_play")[0].svg_text).appendTo($poster_container).on("click",(e) => {
                                        e.stopPropagation();
                                        this.m_prog.player_trailer(movie.trailer_url)
                                    })
                            }
                        var $title=$("<div/>").addClass("movie_title pointer").text(movie.title).appendTo($div).on("click",() => {
                            window.location.href = "#showmovie?id="+movie.id
                        });

                    var $movie_info_container=$("<div/>").addClass("movie_info_container flex-1 ms-0 ms-md-4");
                        // var $title=$("<div/>").addClass("movie_title pointer").text(movie.title).appendTo($movie_info_container).on("click",() => {
                        //     window.location.href = "#showmovie?id="+movie.id
                        // });
                        var $facts=$("<div/>").addClass("d-flex flex-column flex-md-row facts  justify-content-center py-0 py-md-2").appendTo($movie_info_container);
                            if(movie.certification && movie.certification.text){
                                var $certification_id=$("<span/>").addClass("certification").text(movie.certification.text).appendTo($facts);
                                var $span=$("<span/>").addClass("hide-small-screen").text("•").appendTo($facts);
                            }
                            if(movie.localized_genres && !Array.isArray(movie.localized_genres)){
                                movie.localized_genres = movie.localized_genres.replaceAll(",",", ")
                                var $kind=$("<span/>").addClass("kind capitalize").text(movie.localized_genres).appendTo($facts);
                                var $span=$("<span/>").addClass("hide-small-screen").text("•").appendTo($facts);
                            }
                            if(movie.formattedDuration){
                                var $duration=$("<span/>").addClass("runtime").text("("+movie.formattedDuration+")").appendTo($facts);
                            }

                        // Features
                        var $movie_features_container=$("<div/>").addClass("movie_features_container").appendTo($movie_info_container);
                        if(!movie.features){
                            movie.features = [];
                        }
                        if(movie.art_et_essai_actif){
                            if(movie.features.indexOf("art_et_essai")<=0){
                                movie.features.push("art_et_essai");
                            }
                        }
                        // movie.features.forEach(feature => {
                        //     // if(feature=="vf" || feature=="headline"){
                        //     if(feature=="headline"){
                        //         return;
                        //     }
                        //     let feature_url = "https://static.monnaie-services.com/www-img/session/features/"+feature+".png";
                        //     switch(feature){
                        //         default:
                        //             var $img=$("<img/>").addClass("features my-auto").attr({"src":feature_url, "title":_l('#session_feature_'+feature) , "data-feature": feature, "alt":feature}).appendTo($movie_features_container);
                        //             break;
                        //     }
                        // });

                        if(movie.custom_tags){
                            // var $movie_custom_tags_container=$("<div/>").addClass("movie_custom_tags_container").appendTo($movie_info_container);
                            movie.custom_tags.forEach(tag_id => {
                                const data_tag = gl_custom_prog_tags[tag_id];
                                if(!data_tag){
                                    return;
                                }
                                var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($poster_header);
                            });
                        }

                        if(movie.synopsis){
                            var $wrap_synopsis=$("<div/>").addClass("mt-2 wrap_synopsis").appendTo($movie_info_container);
                                var $label=$("<div/>").addClass("bold").text(_l("Synopsis")).appendTo($wrap_synopsis);
                                var $synopsis=$("<span/>").addClass("synopsis").text(movie.synopsis).appendTo($wrap_synopsis);
                        }

                        var $wrap=$("<div/>").addClass("d-flex flex-column flex-md-row mt-2 mt-md-5 wrap_info").appendTo($movie_info_container);
                        if(movie.director){
                            var $box=$("<div/>").addClass("me-md-5").appendTo($wrap);
                                var $text=$("<div/>").addClass("bold").text(_l("Réalisateur")).appendTo($box);
                                var $text=$("<div/>").addClass("text").text(movie.director).appendTo($box);
                        }
                        if(movie.actors){
                            var $box=$("<div/>").addClass("").appendTo($wrap);
                                var $text=$("<div/>").addClass("bold").text(_l("Acteurs")).appendTo($box);
                                var $text=$("<div/>").addClass("text").text(movie.actors).appendTo($box);   
                        } 

                        let $svg_container = $("<div/>").addClass("svg_container icon icon_svg movie-info").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_circle_info")[0].svg_text).appendTo($div);
                            var $tooltip_content=$("<div/>").addClass("d-none").appendTo($svg_container);
                                var $text=$("<div/>").addClass("p-2 m-auto bold box-radius").html($movie_info_container).appendTo($tooltip_content);

                        // $svg_container.attr({"data-bs-toggle":"tooltip"});
                        // $svg_container.attr({"data-bs-html":"true"});
                        // $svg_container.attr({"data-bs-title":$tooltip_content.html()});

                        // let tooltip = new bootstrap.Tooltip($svg_container);

                        $svg_container.tooltip({
                            html:true,
                            title:$tooltip_content.html()
                        });

                var $movie_prog_container=$("<div/>").addClass("movie_prog_container flex-1 ").appendTo($flexbox)
                // var $movie_prog_container=$("<div/>").addClass("movie_prog_container mx-0 mx-md-2").appendTo($movies_container)
                    var $row=$("<div/>").addClass("row mx-0").attr({"id":"row_week_prog"}).appendTo($movie_prog_container);
                        var $col=$("<div/>").addClass("col-12 p-0").appendTo($row);
                            var $table=$("<table/>").addClass("table table-striped table-striped-columns table-bordered").attr({"id":"table_prog_cine_by_week"}).appendTo($col);
                                var $thead=$("<thead/>").appendTo($table);
                                    var $row=$("<tr/>").appendTo($thead);
                                        // var $col=$("<th/>").text(_l("")).appendTo($row);
                                    for(var i=0; i<7; i++){
                                        let day = moment(iParam.first_day).clone().add(i,'days');
                                        var $col=$("<th/>").attr({"width":"","day":day.format("YYYYMMDD")}).appendTo($row);
                                            var $span=$("<div/>").addClass("text-center day").text(day.format("ddd")).appendTo($col);
                                            var $span=$("<div/>").addClass("text-center month").text(day.format("D")).appendTo($col);
                                        if(day.format("YYYYMMDD") == moment().format("YYYYMMDD")){
                                            $col.addClass("today")
                                        }
                                    };
                                var $tbody=$("<tbody/>").appendTo($table);

                                // On créé les lignes regroupés par qualification de séance
                                elem.data.forEach(d => {
                                    d.sessions.forEach(session => {
                                        let specifications_seance = "";
                                        if(movie.art_et_essai_actif){
                                            if(!session.features){
                                                session.features = [];
                                            }
                                            if(session.features.indexOf("art_et_essai")<=0){
                                                session.features.push("art_et_essai");
                                            }
                                        }
                                        if(session.seat_booking && session.features.indexOf("hall_map")<0){
                                            session.features.push("hall_map")
                                        }
                                        session.features.forEach(feature => {
                                            specifications_seance += feature+"_";
                                        });
                                        // specifications_seance += "hall_id_"+session.hall_id;

                                        if($("#week_cine_prog_tr_"+movie.id+"_"+specifications_seance).length <= 0){
                                            var $row_features=$("<tr/>").addClass("").appendTo($tbody);
                                                var $col_features=$("<td/>").attr({"colspan":7}).addClass("text-center col_features").appendTo($row_features);
                                            var $row_hours=$("<tr/>").addClass("").attr({"id":"week_cine_prog_tr_"+movie.id+"_"+specifications_seance}).appendTo($tbody);
                                                session.features.forEach(feature => {
                                                    if(feature=="headline"){
                                                        return;
                                                    }
                                                    let feature_url = "https://static.monnaie-services.com/www-img/session/features/"+feature+".png";
                                                    switch(feature){
                                                        default:
                                                            var $img=$("<img/>").addClass("features my-auto").attr({"src":feature_url, "title":_l('#session_feature_'+feature) , "alt":feature}).appendTo($col_features);
                                                            break;
                                                    }
                                                });

                                            for(var i=0; i<7; i++){
                                                let day = this.week_cine_prog.first_day.clone().add(i,'days');
                                                var $col_hours=$("<td/>").attr({"width":""}).attr({"id":"week_cine_prog_cell_"+day.format("YYYYMMDD")+"_movie_"+movie.id+"_"+specifications_seance}).addClass("text-center").appendTo($row_hours);
                                                if(day.format("YYYYMMDD") == moment().format("YYYYMMDD")){
                                                    $col_hours.addClass("today")
                                                }
                                            }
                                        }
                                    });
                                });

                                // On remplit les bonnes céllules avec les horaires
                                for(var i=0; i<7; i++){
                                    let day = this.week_cine_prog.first_day.clone().add(i,'days');
                                    const sessions_day = elem.data.filter(d => d.date.format("YYYYMMDD") == day.format("YYYYMMDD"))[0];
                                    if(sessions_day && sessions_day.sessions.length > 0){
                                        // var $flex=$("<div/>").addClass("d-flex flex-column").appendTo($col);
                                        let text_hour = "";
                                        sessions_day.sessions.forEach(session => {
                                            let specifications_seance = "";
                                            if(movie.art_et_essai_actif){
                                                if(!session.features){
                                                    session.features = [];
                                                }
                                                if(session.features.indexOf("art_et_essai")<=0){
                                                    session.features.push("art_et_essai");
                                                }
                                            }
                                            if(session.seat_booking && session.features.indexOf("hall_map")<0){
                                                session.features.push("hall_map")
                                            }
                                            session.features.forEach(feature => {
                                                specifications_seance += feature+"_";
                                            });
                                            // specifications_seance += "hall_id_"+session.hall_id;

                                            var $flex=$("<div/>").addClass("d-flex flex-colum pointer session_block").appendTo($("#week_cine_prog_cell_"+day.format("YYYYMMDD")+"_movie_"+movie.id+"_"+specifications_seance)).on("click", () => {
                                                window.location.href = "#showsession?id="+session.id;
                                            })
                                            // if(session.custom_tags){
                                            //     var $session_custom_tags_container=$("<div/>").addClass("session_custom_tags_container").appendTo($flex);
                                            //     session.custom_tags.forEach(tag_id => {
                                            //         const data_tag = gl_custom_prog_tags[tag_id];
                                            //         if(!data_tag){
                                            //             return;
                                            //         }
                                            //         var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($session_custom_tags_container);
                                            //     });
                                            // }
                                                var hour = session.date.substring(8,10) + "h" + session.date.substring(10,12);
                                                var $text=$("<span/>").addClass("session_hour m-auto").text(hour).appendTo($flex);
                                        });
                                    }
                                }

            var $separator=$("<div/>").addClass("separator mb-2").appendTo($("#pane_page_custom_"+this.page_id+" #wrap_program_cine_by_week #wrap_prog_selected_week"));
        });
    }
}

window.gClsPaneCustom = new PageCustom();